<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <div v-if="!showToolPdfsList" class="row">
      <div class="col-md-12">
        <!-- Stats Cards -->
        <div v-if="statusCardsLoaded && !isMobile && userRole !== 'User'" class="row justify-content-center mb-2">
          <div v-for="(card, index) in statsCards" :key="index" class="col-md-6">
            <el-tooltip placement="top" :open-delay="300" effect="dark">
              <template #content>
                <span v-html="getTooltipContent(index)"></span>
              </template>
              <div class="stats-card-wrapper">
                <div class="card">
                  <div class="card-body p-3">
                    <div class="row align-items-center">
                      <div class="col-4">
                        <div class="icon icon-shape shadow text-center border-radius-md" :class="getStatsIconClass(card.type)">
                          <i class="material-icons opacity-10 custom-icon-fit" aria-hidden="true">{{ card.icon }}</i>
                        </div>
                      </div>
                      <div class="col-8">
                        <div class="numbers">
                          <p class="text-sm mb-0 text-uppercase font-weight-bold text-muted">{{ card.subTitle }}</p>
                          <h5 class="font-weight-bolder mb-0">{{ card.title }}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-tooltip>
          </div>
        </div>
        
        <div class="row">
          <div class="col-md-12">
            <rent-loan-form v-if="showRentLoanForm" :tool-id="toolId" :multi-tool="tool.multiTool" :tools-available="toolsAvailable" @close="closeRentLoanForm" @refreshData="fetchData"></rent-loan-form>
            <create-edit-tool-form
              v-if="showDuplicateForm"
              :tool-data="duplicateToolData"
              :is-duplicate="true"
              @close="showDuplicateForm = false"
              @refresh-data="fetchData"
              @navigate-to-tool="navigateToDuplicatedTool"
            />
          </div>
        </div>
        <create-edit-tool-form
          v-if="enableEdit"
          :tool-id="toolId"
          :tool-data="tool"
          @close="handleCancel"
          @refresh-data="fetchData"
        />
        <template v-else>
          <div class="row">
            <div class="col-md-6">
              <card :class="cardSizeClass">
                <h4>{{ toolDisplayName }}</h4>
                <img v-if="tool.toolImageBytes" class="toolImage max-size-image" :src="'data:image/png;base64,' + tool.toolImageBytes" alt="tool alt text" />
                <h5>{{toolStatus}}
                  <div v-if="employee !== '' && !tool.multiTool" class="tool-info"><h6>{{$t('tools.employee')}}: <a class="clickable-link" @click="goToUser">{{ employee }}</a></h6></div>
                  <div v-if="projectName !== '' && !tool.multiTool" class="tool-info"><h6>{{$t('common.project')}}: <a class="clickable-link" @click="goToProject">{{ projectName }}</a></h6></div>
                  <div v-if="reservedTimestamp !== '' && !tool.multiTool" class="tool-info"><h6>{{$t('common.date')}}: {{ reservedTimestamp }}</h6></div>
                  <div v-if="car !== '' && !tool.multiTool" class="tool-info"><h6>{{$t('cars.car')}}: <a class="clickable-link" @click="goToCar">{{ car }}</a></h6></div>
                  <div v-if="externalUserLoanRent !== '' && !tool.multiTool" class="tool-info"><h6>{{$t('tools.loanedRentedTo')}}: {{ externalUserLoanRent }}</h6></div>
                  <div v-if="tool.multiTool" class="tool-info"><h6>{{$t('tools.totalUsed')}}: {{ toolInUse }}/{{tool.totalCount}}</h6></div>
                </h5>
                <div class="row">
                  <div v-if="userRole !== 'User' || allowUsersToMarkBroken || allowToolReservaAndUnreserveWithourQRScan || allowAssigningToolToOtherUser" class="col-md-12">
                    <ul class="navbar-nav d-flex justify-content-end ">
                      <li class="nav-item dropdown w-100">
                        <a class="nav-link dropdown-toggle d-flex align-items-center justify-content-center py-2 btn mb-0 btn-dark btn-block" href="#" role="button"
                          data-bs-toggle="dropdown" aria-expanded="false">
                          {{ $t('common.actions') }}
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end">
                          <li v-if="!isMobile && userRole !== 'User'">
                            <a class="dropdown-item black d-flex align-items-center" @click="printQRCode">
                              <i class="material-icons black me-2">cloud_download</i>
                              {{ $t('tools.printQR') }}
                            </a>
                          </li>
                          <li v-if="userRole !== 'User' && (!isExternalReserved && !isReserved && car === '' && toolStatus === $t('toolStatus.free')) || (tool.multiTool === true && toolStatus !== $t('toolStatus.fullyUsed'))">
                            <a class="dropdown-item black d-flex align-items-center" @click="openRentLoanForm">
                              <i class="material-icons black me-2">directions_run</i>
                              {{ $t('tools.loanRent') }}
                            </a>
                          </li>
                          <li v-if="(allowToolReservaAndUnreserveWithourQRScan || allowAssigningToolToOtherUser) && toolStatus === $t('toolStatus.free') && !isReserved && !isExternalReserved && car === '' && !tool.multiTool">
                            <a class="dropdown-item black d-flex align-items-center" @click="startReserveByButton">
                              <i class="material-icons black me-2">favorite</i>
                              {{ $t('tools.reserve') }}
                            </a>
                          </li>
                          <li v-if="(((isExternalReserved && userRole !== 'User') || (isReserved && allowToolReservaAndUnreserveWithourQRScan)) || (tool.multiTool && ((tool.toolReservations.length > 0 && allowToolReservaAndUnreserveWithourQRScan) || (tool.externalToolReservations.length > 0 && userRole !== 'User')))) && requireQRScanForLoanRentReturns === false">
                            <a class="dropdown-item green d-flex align-items-center" @click="returnTool">
                              <i class="material-icons green me-2">sentiment_satisfied_alt</i>
                              {{ $t('tools.return') }}
                            </a>
                          </li>
                          <li v-if="(toolStatus === $t('toolStatus.free') || toolStatus === $t('toolStatus.inUse') || toolStatus === $t('toolStatus.outOfUse')) && userRole !== 'User'">
                            <a class="dropdown-item orange d-flex align-items-center" @click="confirmChangeStatus($t('toolStatus.broken'))">
                              <i v-if="brokenLoading" class="fa fa-spinner fa-spin me-2"></i>
                              <i v-else class="material-icons orange me-2">error_outline</i>
                              {{ $t('toolStatus.broken') }}
                            </a>
                          </li>
                          <li v-if="(toolStatus === $t('toolStatus.free') || toolStatus === $t('toolStatus.inUse') || toolStatus === $t('toolStatus.broken')) && userRole !== 'User'">
                            <a class="dropdown-item orange d-flex align-items-center" @click="confirmChangeStatus($t('toolStatus.outOfUse'))">
                              <i v-if="outOfUseLoading" class="fa fa-spinner fa-spin me-2"></i>
                              <i v-else class="material-icons orange me-2">block</i>
                              {{ $t('toolStatus.outOfUse') }}
                            </a>
                          </li>
                          <li v-if="(toolStatus === $t('toolStatus.broken') || toolStatus === $t('toolStatus.outOfUse')) && userRole !== 'User'">
                            <a class="dropdown-item green d-flex align-items-center" @click="confirmChangeStatus($t('toolStatus.free'))">
                              <i v-if="freeLoading" class="fa fa-spinner fa-spin me-2"></i>
                              <i v-else class="material-icons green me-2">check_circle</i>
                              {{ $t('toolStatus.free') }}
                            </a>
                          </li>
                          <li v-if="userRole !== 'User'">
                            <a class="dropdown-item black d-flex align-items-center" @click="showToolPdfs()">
                              <i class="material-icons black me-2">picture_as_pdf</i>
                              {{ $t('tools.pdfs') }}
                            </a>
                          </li>
                          <li v-if="enableGPS && userRole !== 'User'">
                            <a class="dropdown-item black d-flex align-items-center" @click="goToGeoTraces()">
                              <i class="material-icons black me-2">place</i>
                              {{ $t('tools.viewGeoTraces') }}
                            </a>
                          </li>
                          <li v-if="userRole !== 'User'">
                            <a class="edit dropdown-item blue d-flex align-items-center" @click="handleEdit">
                              <i class="material-icons blue me-2">edit</i>
                              {{ $t('common.edit') }}
                            </a>
                          </li>
                          <li v-if="userRole !== 'User'">
                            <a class="dropdown-item black d-flex align-items-center" @click="handleDuplicate">
                              <i class="material-icons black me-2">content_copy</i>
                              {{ $t('common.duplicate') }}
                            </a>
                          </li>
                          <li v-if="userRole !== 'User'">
                            <a class="dropdown-item red d-flex align-items-center" @click="handleDelete">
                              <i class="material-icons red me-2">delete_outline</i>
                              {{ $t('common.delete') }}
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </card>
              <UpdateReservationDaysModal
                v-model:show="showUpdateReservationDaysModal"
                :updated-reservation-date="updatedReservationDate"
                :updated-unreservation-date="updatedUnreservationDate"
                :set-price-zero="setPriceZero"
                @update:updatedReservationDate="updatedReservationDate = $event"
                @update:updatedUnreservationDate="updatedUnreservationDate = $event"
                @update:setPriceZero="setPriceZero = $event"
                @submit="updateReservationDays"
              />
              <ReturnMultiToolModal
                v-model:show="showReturnMultiToolModal"
                :multi-tool-return-table="multiToolReturnTable"
                :multi-tool-returning-name="tool ? tool.name : ''"
                :allow-all-users-to-return="false"
                :selected-multi-tools-to-return-rows="selectedMultiToolsToReturnRows"
                @selection-change="({ row, checked }) => handleSelection(row, checked)"
                @confirm="returnMultiTool"
              />
              <UnitInputModal
                v-model:show="showUnitInputModal"
                :units="units"
                :tool-price-type-label="toolPriceTypeLabel"
                @update:units="units = $event"
                @submit="handleUnitInput"
              />
              <project-pick-modal
                :show="showProjectPickModal"
                :status-filter="2"
                order-by="toolReservation"
                @update:show="showProjectPickModal = $event"
                @confirm="onProjectConfirmed"
              />
              <repair-note-modal
                v-model:show="showRepairNoteModal"
                :title="repairNoteModalTitle"
                :placeholder="repairNoteModalPlaceholder"
                :initial-note="editingRepairLogNote"
                @submit="handleRepairNoteSubmit"
              />
              <user-pick-modal
                :show="showUserPickModal"
                :users="usersForPick"
                :selected-user="selectedUser"
                :current-user-id="userId"
                :search-query="userSearchQuery"
                :users-pagination="usersPagination"
                :users-total="usersPagination.total"
                @update:show="showUserPickModal = $event"
                @update:selectedUser="selectedUser = $event"
                @update:searchQuery="userSearchQuery = $event"
                @search="searchUsers"
                @clear-search="handleClearSearchUsers"
                @update-page="updateUserPage"
                @confirm="reserveTool"
              />
            </div>
            <div v-if="toolDataLoaded" class="col-md-6">
              <card :class="cardSizeClass">
                <h4>{{$t('common.info')}}</h4>
                <div class="row">
                  <div class="col-md-8">
                    <ul class="list-group">
                      <li class="pt-0 border-0 list-group-item ps-0">
                        <strong class="text-dark">{{$t('common.description')}}:</strong> &nbsp;
                        {{ tool.description }}
                      </li>
                      <li class="border-0 list-group-item ps-0">
                        <strong class="text-dark">{{$t('tools.brand')}}:</strong> &nbsp; {{ tool.brandName }}
                      </li>
                      <li class="border-0 list-group-item ps-0">
                        <strong class="text-dark">{{$t('locations.location')}}:</strong> &nbsp; {{ locationOption }}
                      </li>
                      <li class="border-0 list-group-item ps-0">
                        <strong class="text-dark">{{$t('common.type')}}:</strong> &nbsp;
                        {{ toolTypeOption }}
                      </li>
                      <li v-if="!enableToolPriceTypes" class="border-0 list-group-item ps-0">
                        <strong class="text-dark">{{$t('tools.dailyPrice')}}:</strong> &nbsp;
                        {{ tool.dailyPrice }}
                      </li>
                      <li v-else class="border-0 list-group-item ps-0">
                        <strong class="text-dark">{{$t('tools.cost')}}:</strong> &nbsp;
                        {{ tool.dailyPrice }} kr/{{ toolPriceTypeLabel }}
                      </li>
                      <li class="border-0 list-group-item ps-0">
                        <strong class="text-dark">{{$t('tools.purchaseDate')}}:</strong> &nbsp;
                        {{ purchaseDateGoodFormat }}
                      </li>
                      <li class="border-0 list-group-item ps-0">
                        <strong class="text-dark">{{$t('tools.purchasePrice')}}:</strong> &nbsp;
                        {{ tool.purchasePrice }}
                      </li>
                      <li class="border-0 list-group-item ps-0">
                        <strong class="text-dark">{{$t('tools.isle')}}:</strong> &nbsp;
                        {{ tool.isle }}
                      </li>
                      <li class="border-0 list-group-item ps-0">
                        <strong class="text-dark">{{$t('tools.shelf')}}:</strong> &nbsp;
                        {{ tool.shelf }}
                      </li>
                      <li class="border-0 list-group-item ps-0">
                        <strong class="text-dark">{{$t('tools.maxReservationDays')}}:</strong> &nbsp;
                        {{ maxReservationDaysDisplayValue }}
                      </li>
                      <li class="border-0 list-group-item ps-0">
                        <strong class="text-dark">Serial:</strong> &nbsp;
                        {{ tool.sku }}
                      </li>
                      <li v-if="tool.deviceId" class="border-0 list-group-item ps-0">
                        <strong class="text-dark">{{ $t('tools.gpsDevice') }}:</strong> &nbsp;
                        {{ tool.deviceTypeName }} {{ tool.deviceId }}
                        <span v-if="tool.deviceBatteryPct != null">
                          <i class="fas fa-battery-full ms-2 me-1" :style="{ color: batteryColor }"></i>
                          {{ Math.round(tool.deviceBatteryPct) }}%
                        </span>
                        <device-status-badge class="ms-2" :last-contact="tool.deviceLastContact" />
                      </li>
                      <li v-if="tool.deviceLastAddress" class="border-0 list-group-item ps-0">
                        <strong class="text-dark">{{ $t('tools.deviceLastAddress') }}:</strong> &nbsp;
                        {{ tool.deviceLastAddress }}
                      </li>
                      <li v-if="tool.multiTool" class="border-0 list-group-item ps-0">
                        <strong class="text-dark">{{$t('tools.totalCount')}}:</strong> &nbsp;
                        {{ tool.totalCount }}
                      </li>
                    </ul>
                    
                    <!-- <h4><strong>{{$t('common.description')}}: </strong> {{ tool.description }}</h4>
                    <h4><strong>{{$t('tools.brand')}}: </strong>{{ tool.brandName }}</h4>
                    <h4><strong>{{$t('locations.location')}}: </strong> {{ locationOption }}</h4>
                    <h4><strong>{{$t('common.type')}}: </strong> {{ toolTypeOption }}</h4>
                    <h4 v-if="!enableToolPriceTypes"><strong>{{$t('tools.dailyPrice')}}: </strong> {{ tool.dailyPrice }}</h4>
                    <h4 v-else><strong>{{$t('tools.cost')}}: </strong> {{ tool.dailyPrice }} kr/{{ toolPriceTypeLabel }}</h4>
                    <h4><strong>{{$t('tools.purchaseDate')}}: </strong> {{ purchaseDateGoodFormat }}</h4>
                    <h4><strong>{{$t('tools.purchasePrice')}}: </strong> {{ tool.purchasePrice }}</h4>
                    <h4><strong>{{$t('tools.isle')}}: </strong> {{ tool.isle }}</h4>
                    <h4><strong>{{$t('tools.shelf')}}: </strong> {{ tool.shelf }}</h4>
                    <h4><strong>{{$t('tools.maxReservationDays')}}: </strong> {{ maxReservationDaysDisplayValue }}</h4>
                    <h4><strong>Serial: </strong> {{ tool.sku }}</h4>
                    <h4 v-if="tool.multiTool"><strong>{{$t('tools.totalCount')}}: </strong> {{ tool.totalCount }}</h4> -->
                  </div>
                  <div v-if="userRole !== 'User'" class="col-md-4">
                    <div v-if="tool.id" class="qr-container" @click="printQRCode">
                      <img :src="qrCodeBanner" alt="app-logo" style="width: 100px; height: auto; margin-bottom: 6px;" />
                      <qrcode-vue
                        ref="printqrcode"
                        render-as="svg"
                        :value="qrValue"
                        :size="qrDisplaySize"
                        level="H"
                        background="#ffffff"
                        foreground="#000000"
                      >
                      </qrcode-vue>
                    </div>
                    <div v-if="tool.id && !isMobile" class="mt-2">
                      <select v-model="selectedLabelSize" class="form-select form-select-sm" @change="saveLabelSize">
                        <option v-for="size in labelSizeOptions" :key="size.value" :value="size.value">{{ size.label }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </template>
        <div v-show="false" class="row">
          <card type="toolqr">
            <p class="card-text"></p>
            <div v-if="tool.id" class="qr-print-container">
              <div >
                <img :src=qrCodeBanner alt="app-logo" class="print-logo"/>
              </div>
              <qrcode-vue
                ref="printqrcode"
                render-as="svg"
                :value="qrValue"
                :size="qrPrintSize"
                level="H"
                background="#ffffff"
                foreground="#000000"
              >
              </qrcode-vue>
              <h3>{{ toolDisplayName }}</h3>
            </div>
          </card>
        </div>
      </div>
    </div>
    <div v-if="!enableEdit && !showToolPdfsList" class="row" :class="{'table-min-size': !isMobile}">
      <card :title="cardTitle" class="card-body">
        <template #table-select>
          <NavPills
            :model-value="activeIndex"
            :items="toolNavPillItems"
            @update:model-value="initTable"
          />
        </template>
        <template v-if="activeEntity === 'Reminders'">
          <div v-if="userRole !== 'User'" class="d-flex justify-content-end mb-3">
            <material-button color="dark" size="sm" @click="openReminderModal()">{{ $t('tools.addReminder') }}</material-button>
          </div>
          <div v-if="!tool.reminders || tool.reminders.length === 0" class="text-muted">{{ $t('tools.noReminders') }}</div>
          <div v-for="reminder in tool.reminders" :key="reminder.id" class="d-flex align-items-center mb-2">
            <i class="material-icons me-2">notifications</i>
            <div class="flex-grow-1">
              <div>{{ reminder.label }}</div>
              <div class="text-sm text-muted">
                <span :class="{ 'text-danger': isReminderOverdue(reminder.dueDate) }">{{ formatReminderDate(reminder.dueDate) }}</span>
                <span v-if="reminderNotifySummary(reminder)"> · {{ reminderNotifySummary(reminder) }}</span>
                <span v-if="reminder.recipientUserIds && reminder.recipientUserIds.length"> · {{ reminder.recipientUserIds.length }} {{ $t('tools.reminderExtraRecipientsCount') }}</span>
              </div>
            </div>
            <a v-if="userRole !== 'User'" role="button" class="me-2" :title="$t('common.edit')" @click="openReminderModal(reminder)">
              <i class="material-icons">edit</i>
            </a>
            <a v-if="userRole !== 'User'" role="button" :title="$t('common.delete')" @click="deleteReminder(reminder)">
              <i class="material-icons text-danger">delete</i>
            </a>
          </div>
        </template>
        <template v-else-if="tableDataReady">
          <div class="table-responsive">
            <el-base-table
              :table-data="tableData.data"
              :table-columns="tableData.columns"
              :table-settings="tableData.settings" />
          </div>
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap pagination">
            <div class="">
              <p class="card-category">{{ $t('pagination.showing') }} {{ pagination_from + 1 }} {{ $t('pagination.to') }} {{ pagination_to }} {{ $t('pagination.of') }} {{ pagination_total }} {{ $t('pagination.entries') }} </p>
            </div>
            <material-pagination color="info" class="pagination-no-border">
              <material-pagination-item
                prev
                :disabled="pagination.currentPage === 1"
                @click="prevPage"
              />
              <material-pagination-item
                v-for="page in displayedPages"
                :key="page"
                :label="String(page)"
                :active="pagination.currentPage === page"
                @click="changePage(page)"
              />
              <material-pagination-item
                next
                :disabled="pagination.currentPage === totalPages"
                @click="nextPage"
              />
            </material-pagination>
          </div>
        </template>
      </card>
    </div>

    <!-- Tool PDF View -->
    <div v-if="showToolPdfsList">
      <div class="row">
        <div class="col-md-12">
          <h3>
            <a role="button" class="me-2" @click="closeToolPdfs()">
              <i class="material-icons">arrow_back</i>
            </a>
            {{ toolDisplayName }}
          </h3>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <card :title="$t('tools.pdfs')" :on-add-object="userRole !== 'User' ? openToolPdfUpload : null">
            <div v-if="toolPdfsList.length === 0" class="text-muted">{{ $t('tools.noPdfs') }}</div>
            <div v-for="pdf in toolPdfsList" :key="pdf.id" class="tool-pdf-item d-flex align-items-center mb-2">
              <i class="material-icons me-2 text-danger">picture_as_pdf</i>
              <span class="me-3">{{ pdf.filename }}</span>
              <a role="button" class="me-2" :title="$t('tools.viewPdf')" @click="viewToolPdf(pdf)">
                <i class="material-icons">visibility</i>
              </a>
              <a role="button" class="me-2" :title="$t('tools.downloadPdf')" @click="downloadToolPdf(pdf)">
                <i class="material-icons">download</i>
              </a>
              <a v-if="userRole !== 'User'" role="button" :title="$t('common.delete')" @click="deleteToolPdf(pdf.id)">
                <i class="material-icons text-danger">delete</i>
              </a>
            </div>
          </card>
        </div>
      </div>
    </div>

    <!-- Tool PDF Upload Modal -->
    <modal v-model:show="showToolPdfUpload" class="overflow-auto">
      <card :title="$t('tools.addPdf')">
        <div class="row mb-3">
          <div class="col-12">
            <input ref="toolPdfFileInput" type="file" multiple accept="application/pdf" @change="handleToolPdfFiles" />
          </div>
        </div>
        <div class="row">
          <div class="col-sm d-flex justify-content-end">
            <material-button color="dark" type="standard" fill :disabled="toolPdfUploadInProgress" @click="uploadToolPdfsToS3">
              <i v-if="toolPdfUploadInProgress" class="fas fa-spinner fa-spin me-2"></i>
              {{ $t('common.confirm') }}
            </material-button>
          </div>
        </div>
      </card>
    </modal>

    <!-- Tool Reminder Add/Edit Modal -->
    <modal v-model:show="showReminderModal" class="overflow-auto">
      <card :title="reminderForm.id ? $t('tools.editReminder') : $t('tools.addReminder')">
        <div class="mb-3">
          <label class="form-label text-sm">{{ $t('tools.reminderLabel') }} *</label>
          <input
            v-model="reminderForm.label"
            type="text"
            class="form-control"
            :placeholder="$t('tools.reminderLabel')"
          />
        </div>
        <div class="mb-3">
          <label class="form-label text-sm">{{ $t('tools.reminderDate') }} *</label>
          <el-date-picker
            v-model="reminderForm.dueDate"
            type="date"
            :placeholder="$t('tools.reminderDate')"
            format="DD/MM/YYYY"
            value-format="YYYY-MM-DD"
            :clearable="true"
            class="w-100"
          />
        </div>
        <div class="d-flex flex-wrap mb-3">
          <div class="form-check me-3">
            <input
              id="reminderNotifyMonthBefore"
              v-model="reminderForm.notifyMonthBefore"
              type="checkbox"
              class="form-check-input"
            />
            <label class="form-check-label" for="reminderNotifyMonthBefore">
              {{ $t('tools.notifyMonthBefore') }}
            </label>
          </div>
          <div class="form-check me-3">
            <input
              id="reminderNotifyWeekBefore"
              v-model="reminderForm.notifyWeekBefore"
              type="checkbox"
              class="form-check-input"
            />
            <label class="form-check-label" for="reminderNotifyWeekBefore">
              {{ $t('tools.notifyWeekBefore') }}
            </label>
          </div>
          <div class="form-check">
            <input
              id="reminderNotifyOnDate"
              v-model="reminderForm.notifyOnDate"
              type="checkbox"
              class="form-check-input"
            />
            <label class="form-check-label" for="reminderNotifyOnDate">
              {{ $t('tools.notifyOnDate') }}
            </label>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label text-sm">{{ $t('tools.reminderExtraRecipients') }}</label>
          <el-select
            v-model="reminderForm.recipientUserIds"
            multiple
            filterable
            clearable
            :placeholder="$t('tools.reminderExtraRecipients')"
            class="w-100"
          >
            <el-option
              v-for="u in reminderUserOptions"
              :key="u.id"
              :value="u.id"
              :label="`${u.firstName || ''} ${u.lastName || ''}`.trim() + (u.email ? ` (${u.email})` : '')"
            />
          </el-select>
          <p class="text-sm text-muted mb-0">{{ $t('tools.reminderAdminsAlwaysNotified') }}</p>
        </div>
        <div class="row">
          <div class="col-sm d-flex justify-content-end">
            <material-button color="dark" type="standard" fill :disabled="reminderSaving" @click="saveReminder">
              <i v-if="reminderSaving" class="fas fa-spinner fa-spin me-2"></i>
              {{ $t('common.confirm') }}
            </material-button>
          </div>
        </div>
      </card>
    </modal>

    <!-- Reservation Image Upload Modal -->
    <modal v-model:show="showImageUpload" class="overflow-auto">
      <card :title="$t('projects.addImage')">
        <div class="row mb-3">
          <div class="col-12">
            <file-pond
              ref="pond"
              name="images"
              :allow-multiple="true"
              :accepted-file-types="['image/jpeg', 'image/png', 'image/webp', 'image/heic']"
              :max-file-size="'8MB'"
              :label-idle="$t('projects.pressHere')"
              @updatefiles="handleImageUpdate"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm d-flex justify-content-end">
            <material-button color="dark" type="standard" fill :disabled="imageUploadInProgress" @click="uploadImagesToS3">
              <i v-if="imageUploadInProgress" class="fas fa-spinner fa-spin me-2"></i>
              <span v-if="uploadStage === 'compressing'">{{ $t('common.compressing', compressionProgress) }}</span>
              <span v-else-if="uploadStage === 'uploading'">{{ $t('common.uploading') }}</span>
              <span v-else>{{ $t('common.confirm') }}</span>
            </material-button>
          </div>
        </div>
      </card>
    </modal>

    <!-- Reservation Images Gallery Modal -->
    <modal v-model:show="showingGallery" class="overflow-auto">
      <card :title="$t('projects.images')">
        <div class="row">
          <div
            v-for="(item, index) in galleryItems"
            :key="item.id"
            class="col-6 col-md-4 mb-3"
          >
            <img :src="item.thumbnail" class="img-fluid rounded gallery-thumb" alt="reservation image" @click="activeImageIndex = index" />
          </div>
        </div>
        <div v-if="galleryItems.length === 0" class="text-muted">
          {{ $t('tools.noImages') }}
        </div>
      </card>
    </modal>
    <ImageLightbox v-model:index="activeImageIndex" :images="galleryItems" />
  </div>
</template>
<script>
import api from "../../services/api"; // Import your API service
import { loadCustomerMeCached } from '../../services/customerMeHelper';
import QrcodeVue from 'qrcode.vue'; // Import QrcodeVue from qrcode.vue
import config from "@/config";
import CreateEditToolForm from "./CreateEditToolForm.vue";
import { jwtDecode } from "jwt-decode";
import Cookies from 'js-cookie';
import { ElTooltip, ElDatePicker, ElSelect, ElOption } from 'element-plus';
import { getApiErrorMessage } from "../../utils/apiError";
import RentLoanForm from "./RentLoanForm";
import swal from 'sweetalert2';
import MaterialPagination from '../../components/MaterialPagination.vue';
import MaterialPaginationItem from '../../components/MaterialPaginationItem.vue';
import ElBaseTable from "../../components/ElBaseTable.vue";
import { getCustomerConfig } from '../Settings/customerConfigHelper';
import Card from "../../components/Card.vue";
import ProjectPickModal from "../../components/Modals/ProjectPickModal.vue";
import UserPickModal from "../../components/Modals/UserPickModal.vue";
import UpdateReservationDaysModal from "../../components/Modals/UpdateReservationDaysModal.vue";
import ReturnMultiToolModal from "../../components/Modals/ReturnMultiToolModal.vue";
import UnitInputModal from "../../components/Modals/UnitInputModal.vue";
import NavPills from "../../components/NavPills.vue";
import Modal from "../../components/Modals/Modal.vue";
import MaterialButton from "../../components/MaterialButton.vue";
import DeviceStatusBadge from "../../components/DeviceStatusBadge.vue";
import ImageLightbox from "../../components/ImageLightbox.vue";
import axios from 'axios';
import { compressImagesForUpload, uploadToPresignedUrl } from '../../services/imageUpload';
import RepairNoteModal from "../../components/Modals/RepairNoteModal.vue";
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

export default {
  components: {
    QrcodeVue,
    ProjectPickModal,
    UserPickModal,
    UpdateReservationDaysModal,
    ReturnMultiToolModal,
    UnitInputModal,
    RepairNoteModal,
    RentLoanForm,
    MaterialPagination,
    MaterialPaginationItem,
    'el-base-table': ElBaseTable,
    Card,
    ElTooltip,
    ElDatePicker,
    ElSelect,
    ElOption,
    CreateEditToolForm,
    NavPills,
    Modal,
    MaterialButton,
    DeviceStatusBadge,
    ImageLightbox,
    FilePond,
  },
  data() {
    return {
      showQRBannerUpload: false,
      showReturnMultiToolModal: false,
      purchaseDateGoodFormat:"",
      isReserved: false,
      isExternalReserved: false,
      requireQRScanForLoanRentReturns: false,
      showRentLoanForm: false,
      showDuplicateForm: false,
      toolsAvailable: 0,
      toolId: 0,
      tool: {}, // This will hold the tool data
      onCreatedTool: {}, // This will store the original tool values so we don't have to call fetch data again on cancel
      includeOwnerInformation: true,
      enableEdit: false,
      toolTypeOptions: [],
      locationOptions: [],
      updateToolStatusOptions: [
        {id: 1, status: this.$t('toolStatus.free'), loading: false, icon: 'tim-icons icon-triangle-right-17', color: 'green'},
        {id: 3, status: this.$t('toolStatus.broken'), loading: false, icon: 'tim-icons icon-simple-delete', color: 'orange'},
        {id: 4, status: this.$t('toolStatus.outOfUse'), loading: false, icon: 'tim-icons icon-simple-remove', color: 'orange'},
      ],
      toolTypeOption: "",
      locationOption: "",
      updatedStatus:"",
      toolStatus:"",
      toolTypeId: "",
      newToolType: "",
      maxReservationDaysDisplayValue: "",
      userId: '',
      userRole: null,
      qrDisplaySize: 128,
      qrPrintSize: 500,
      selectedLabelSize: localStorage.getItem('labelSize') || '3x2',
      labelSizeOptions: [
        { value: '2x2', label: '2 x 2 inches' },
        { value: '3x2', label: '3 x 2 inches' },
        { value: '3x3', label: '3 x 3 inches' },
        { value: '4x4', label: '4 x 4 inches' },
        { value: '1x1', label: '1 x 1 inch' },
      ],
      isMobile: window.innerWidth <= 1024,
      employee: "",
      employeeId: "",
      reservedTimestamp: "",
      projectName: "",
      projectId: "",
      car: "",
      carId: "",
      externalUserLoanRent: "",
      toolDisplayName: "",
      showUpdateReservationDaysModal: false,
      updateDays: '',
      latestUnreservedId: '',
      loading: false,
      toolInUse: 0,
      tableDataReady: false,
      tableData: {},
      multiToolReturnTable: [],
      multiToolIdsToReturn:[],
      multiToolIdsToExternalReturn:[],
      selectedMultiToolsToReturnRows: {},
      enableCustomQRBanner: false,
      enableGPS: false,
      customerCustomQRBanner: null,
      cardTitle: this.$t('projects.reservationHistory'),
      activeIndex: 0,
      pagination: {
        perPage: 5,
        currentPage: 1,
        total: 0
      },
      updatedReservationDate: null,
      updatedUnreservationDate: null,
      setPriceZero: false,
      toolPriceTypePlaceholder: "",
      toolPriceTypeOption: null,
      toolPriceTypeOptions: [
        {id: 1, type: this.$t('toolPriceType.day')},
        {id: 2, type: this.$t('toolPriceType.hour')},
        {id: 3, type: this.$t('toolPriceType.kilometer')},
        {id: 4, type: this.$t('toolPriceType.meter')},
      ],
      enableToolPriceTypes: false,
      loanRentCustomer: false,
      toolDataLoaded: false,
      toolPriceTypeLabel: "",
      showUnitInputModal: false,
      units: null,
      allowUsersToMarkBroken: false,
      allowToolReservaAndUnreserveWithourQRScan: false,
      allowAssigningToolToOtherUser: false,
      enableProjectPhases: false,
      showProjectPickModal: false,
      selectedProject: null,
      selectedProjectPhase: null,
      showUserPickModal: false,
      usersForPick: [],
      userSearchQuery: '',
      selectedUser: null,
      usersPagination: { perPage: 5, currentPage: 1, total: 0 },
      initialTableReady: false,
      // Stats card data
      statsCards: [],
      statusCardsLoaded: false,
      totalRevenue: 0,
      externalRevenue: 0,
      internalRevenue: 0,
      totalRevenueCounter: 0,
      externalRevenueCounter: 0,
      internalRevenueCounter: 0,
      profitMultiplier: null,
      // Tool PDFs
      showToolPdfsList: false,
      showToolPdfUpload: false,
      toolPdfUploadInProgress: false,
      toolPdfsList: [],
      toolPdfUploadFiles: [],
      enableToolReminders: false,
      showReminderModal: false,
      reminderSaving: false,
      reminderForm: { id: null, label: '', dueDate: '', notifyMonthBefore: false, notifyWeekBefore: false, notifyOnDate: true, recipientUserIds: [] },
      reminderUserOptions: [],
      reminderUsersLoaded: false,
      requireRepairNotes: false,
      showRepairNoteModal: false,
      repairNoteModalTitle: '',
      repairNoteModalPlaceholder: '',
      pendingStatusChange: null,
      pendingFromStatusId: null,
      pendingToStatusId: null,
      editingRepairLogId: null,
      editingRepairLogNote: '',
      askForToolImageOnReturnForToolReservations: false,
      askForToolImageOnReturnForToolReservationsAfterDays: 1,
      askForToolImageOnReturnForExternalToolReservations: false,
      showImageUpload: false,
      externalToolReservationImageUpload: false,
      uploadImages: [],
      imageUploadInProgress: false,
      uploadStage: null,
      compressionProgress: { done: 0, total: 0 },
      galleryItems: [],
      activeImageIndex: null,
      showingGallery: false,
    };
  },
  computed: {
    batteryColor() {
      const pct = this.tool?.deviceBatteryPct;
      if (pct == null) return '';
      if (pct <= 10) return '#dc3545';
      if (pct <= 39) return '#ffc107';
      return '#28a745';
    },
    duplicateToolData() {
      if (!this.tool) return null;
      return { ...this.tool, name: (this.tool.name || '') + '-Copy' };
    },
    toolNavPillItems() {
      const items = [];
      if (this.tool.multiTool) {
        items.push({ label: this.$t('tools.inUse'), icon: 'person' });
      }
      items.push({ label: this.$t('projects.reservationHistory'), icon: 'notes' });
      items.push({ label: this.$t('projects.loanRentHistory'), icon: 'description' });
      items.push({ label: this.$t('repairLog.repairHistory'), icon: 'build' });
      if (this.enableToolReminders) {
        items.push({ label: this.$t('tools.toolReminders'), icon: 'notifications' });
      }
      return items;
    },
    qrCodeBanner()
    {
      if (this.tool.toolQRCodeBanner === null && this.customerCustomQRBanner === null)
      {
        return 'img/sidebar-header-tolspor2.png'
      }
      else if(this.tool.toolQRCodeBanner !== null)
      {
        return 'data:image/png;base64,' + this.tool.toolQRCodeBanner
      }
      else
      {
        return 'data:image/png;base64,' + this.customerCustomQRBanner
      }
    },
    bannerSrc() {
      return this.tool.toolQRCodeBanner ? 'data:image/png;base64,' + this.tool.toolQRCodeBanner : null;
    },
    qrValue() {
      // Combine the base URL with the tool ID to create the full URL
      let qrUrl = `${config.baseUrl}/tool/${this.tool.id}`;
      return qrUrl;
    },
    pagination_to() {
      let highBound = this.pagination_from + this.pagination.perPage;
      if (this.pagination_total < highBound) {
        highBound = this.pagination_total;
      }
      return highBound;
    },
    pagination_from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    pagination_total() {
      return this.pagination.total;
    },
    totalPages() {
      if (this.pagination_total > 0) {
        return Math.ceil(this.pagination_total / this.pagination.perPage);
      }
      return 1;
    },
    displayedPages() {
      const pages = [];
      const maxPages = Math.min(5, this.totalPages);

      let startPage = Math.max(1, this.pagination.currentPage - Math.floor(maxPages / 2));
      let endPage = startPage + maxPages - 1;

      if (endPage > this.totalPages) {
        endPage = this.totalPages;
        startPage = Math.max(1, endPage - maxPages + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    },
    myTablesCategories() {
      // How the table data is loaded is highly dependant on the ordering in this list, any changes here will need to be reflected in the init table method
      if(this.tool.multiTool)
      {
        return [{ name: this.$t('tools.inUse'), icon: 'tim-icons icon-single-02' },{ name: this.$t('projects.reservationHistory'), icon: 'tim-icons icon-notes' }, { name: this.$t('projects.loanRentHistory'), icon: 'tim-icons icon-paper' }];
      }
      else
      {
        return [{ name: this.$t('projects.reservationHistory'), icon: 'tim-icons icon-notes' }, { name: this.$t('projects.loanRentHistory'), icon: 'tim-icons icon-paper' }];
      }
    },
    selectClass() {
      let darkMode = localStorage.getItem('darkMode');
      // If darkMode does not exist in localStorage, default it to 'false'
      if (darkMode === null) {
        darkMode = 'false';
      }
      if (darkMode === 'false') {
        return 'select-standard';
      } else {
        return 'select-primary';
      }
    },
    selectButtonClass() {
      let darkMode = localStorage.getItem('darkMode');
      // If darkMode does not exist in localStorage, default it to 'false'
      if (darkMode === null) {
        darkMode = 'false';
      }
      if (darkMode === 'false') {
        return 'btn-standard';
      } else {
        return 'btn-primary';
      }
    },
    cardSizeClass() {
      var cardClass = '';
      if (!this.isMobile) {
        if (!this.isExternalReserved && !this.isReserved && !this.tool.multiTool) {
          cardClass = 'max-size-free';
        }
        else {
          cardClass = 'max-size-reservation';
        }
      }
      return cardClass;
    },
  },
  watch: {
    '$route.params.toolId'(newId) {
      if (newId && newId !== this.toolId) {
        this.toolId = newId;
        this.fetchData();
      }
    },
    showImageUpload(newValue) {
      if (!newValue) {
        this.clearFilePond();
      }
    },
    showQRBannerUpload(newValue) {
      if (newValue === false) {
        this.tool.toolQRCodeBanner = null
      }
    },
    initialTableReady(newVal) {
      if (newVal && !this.enableEdit) {
        this.$nextTick(() => this.initTable(this.activeIndex));
      }
    },
  },
  mounted() {},
  beforeUnmount() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
  created() {
    window.addEventListener('resize', this.updateIsMobile);
    getCustomerConfig('EnableCustomQRBanner')
      .then(config => {
        if(config === '')
        {
          this.enableCustomQRBanner = false
        }
        else
        {
          this.enableCustomQRBanner = config
        }
      })
    getCustomerConfig('EnableGPS')
      .then(config => {
        this.enableGPS = config === '' ? false : config
      })
    getCustomerConfig('EnableToolPriceTypes')
      .then(config => {
        if(config === '')
        {
          this.enableToolPriceTypes = false
        }
        else
        {
          this.enableToolPriceTypes = config
        }
      })
      getCustomerConfig('AllowUsersToMarkBroken')
      .then(config => {
        if(config === '')
        {
          this.allowUsersToMarkBroken = false
        }
        else
        {
          this.allowUsersToMarkBroken = config
        }
      })
    getCustomerConfig('AllowToolReservaAndUnreserveWithourQRScan')
      .then(config => {
        this.allowToolReservaAndUnreserveWithourQRScan = config === '' ? false : config;
      })
    getCustomerConfig('AllowAssigningToolToOtherUser')
      .then(config => {
        this.allowAssigningToolToOtherUser = config === '' ? false : config;
      })
    getCustomerConfig('EnableProjectPhases')
      .then(config => {
        this.enableProjectPhases = config === true;
      })
    getCustomerConfig('RequireQRScanForLoanRentReturns')
      .then(config => {
        this.requireQRScanForLoanRentReturns = config === '' ? false : config;
      })
    getCustomerConfig('LoanRentCustomer')
      .then(config => {
        this.loanRentCustomer = config === '' ? false : config;
        this.fetchData()
      })
    getCustomerConfig('RequireRepairNotes')
      .then(config => {
        this.requireRepairNotes = config === '' ? false : config;
      })
    getCustomerConfig('AskForToolImageOnReturnForToolReservations')
      .then(config => {
        this.askForToolImageOnReturnForToolReservations = config === '' ? false : config;
      })
    getCustomerConfig('AskForToolImageOnReturnForToolReservationsAfterDays')
      .then(config => {
        const n = Number(config);
        this.askForToolImageOnReturnForToolReservationsAfterDays = Number.isFinite(n) && n >= 1 ? Math.floor(n) : 1;
      })
    getCustomerConfig('AskForToolImageOnReturnForExternalToolReservations')
      .then(config => {
        this.askForToolImageOnReturnForExternalToolReservations = config === '' ? false : config;
      })
    getCustomerConfig('EnableToolReminders')
      .then(config => {
        this.enableToolReminders = config === '' ? false : config;
      })
    this.toolId = this.$route.params.toolId;
    const token = Cookies.get('accessToken');
    const decodedToken = jwtDecode(token);
    this.userId = decodedToken.UserIdentifier;
    this.userRole = decodedToken.role;
    if(this.$route.params.editMode)
    {
      this.handleEdit();
    }
  },
  methods: {
    updateIsMobile() {
      this.isMobile = window.innerWidth <= 1024;
    },
    checkIfImageUploadIsRequired(reservedTimestamp, unreservedTimestamp, tool) {
      if (this.externalToolReservationImageUpload) {
        return this.askForToolImageOnReturnForExternalToolReservations;
      }
      const enabled = tool?.askForToolImageOnReturnForToolReservations ?? this.askForToolImageOnReturnForToolReservations;
      if (!enabled) return false;
      if (!reservedTimestamp || !unreservedTimestamp) return true;
      const elapsedMs = new Date(unreservedTimestamp) - new Date(reservedTimestamp);
      const days = Math.max(1, Math.ceil(elapsedMs / (1000 * 60 * 60 * 24)));
      const threshold = tool?.askForToolImageOnReturnForToolReservationsAfterDays ?? this.askForToolImageOnReturnForToolReservationsAfterDays;
      return days >= threshold;
    },
    changeStatus(status) {
      const clickedOption = this.updateToolStatusOptions.find(option => option.status === status);
      if (clickedOption) {
        // Check if repair notes are required for this status change
        const currentStatusId = this.updateToolStatusOptions.find(o => o.status === this.toolStatus)?.id ?? this.tool.toolStatusId;
        const isToBroken = clickedOption.id === 3;
        const isToOutOfUse = clickedOption.id === 4;
        const isToFreeFromBroken = clickedOption.id === 1 && currentStatusId === 3;
        const isToFreeFromOutOfUse = clickedOption.id === 1 && currentStatusId === 4;
        if (this.requireRepairNotes && (isToBroken || isToOutOfUse || isToFreeFromBroken || isToFreeFromOutOfUse)) {
          this.pendingStatusChange = status;
          this.pendingFromStatusId = currentStatusId;
          this.pendingToStatusId = clickedOption.id;
          if (isToFreeFromBroken) {
            this.repairNoteModalTitle = this.$t('repairLog.reportFreeFromBrokenTitle');
            this.repairNoteModalPlaceholder = this.$t('repairLog.reportFreeFromBrokenPlaceholder');
          } else if (isToFreeFromOutOfUse) {
            this.repairNoteModalTitle = this.$t('repairLog.reportFreeFromOutOfUseTitle');
            this.repairNoteModalPlaceholder = this.$t('repairLog.reportFreeFromOutOfUsePlaceholder');
          } else if (isToOutOfUse) {
            this.repairNoteModalTitle = this.$t('repairLog.reportOutOfUseTitle');
            this.repairNoteModalPlaceholder = this.$t('repairLog.reportOutOfUsePlaceholder');
          } else {
            this.repairNoteModalTitle = this.$t('repairLog.reportBrokenTitle');
            this.repairNoteModalPlaceholder = this.$t('repairLog.reportBrokenPlaceholder');
          }
          this.showRepairNoteModal = true;
          return;
        }
        clickedOption.loading = true;
        this.updatedStatus = status;
        this.handleUpdate().finally(() => {
          // After the operation is complete, stop loading
          clickedOption.loading = false;
        });
      }
    },
    async handleRepairNoteSubmit(note) {
      this.showRepairNoteModal = false;
      // Edit mode: update existing log entry
      if (this.editingRepairLogId !== null) {
        try {
          await api.put(`/ToolRepairLog/${this.editingRepairLogId}`, { note });
          await this.fetchRepairHistoryTableData();
        } catch (error) {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
        } finally {
          this.editingRepairLogId = null;
          this.editingRepairLogNote = '';
        }
        return;
      }
      // Create mode: change status and log
      const status = this.pendingStatusChange;
      const clickedOption = this.updateToolStatusOptions.find(option => option.status === status);
      if (!clickedOption) return;
      clickedOption.loading = true;
      this.updatedStatus = status;
      try {
        await this.handleUpdate();
        await api.post(`/ToolRepairLog/${this.tool.id}`, {
          fromStatusId: this.pendingFromStatusId,
          toStatusId: this.pendingToStatusId,
          note: note
        });
      } catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
      } finally {
        clickedOption.loading = false;
        this.pendingStatusChange = null;
        this.pendingFromStatusId = null;
        this.pendingToStatusId = null;
      }
    },
    confirmChangeStatus(status)
    {
      let confirmationTitle = ''
      let confirmationMessage = ''
      let needsUserConfirmation = false
      let removeFromCar = false
      let needsUnreserve = false
      let needsBoth = false
      if(this.car !== '')
      {
        confirmationTitle = this.$t('tools.toolIsInCar')
        confirmationMessage = this.$t('tools.toolWillBeRemovedFromCar')
        needsUserConfirmation = true
        removeFromCar = true
      }
      if(this.employee !== '')
      {
        confirmationTitle = this.$t('tools.toolIsReservedBy') + ' ' + this.employee
        confirmationMessage = this.$t('tools.toolWillBeUnreserved')
        needsUserConfirmation = true
        needsUnreserve = true
      }
      if(needsUnreserve===true && removeFromCar===true)
      {
        confirmationTitle = this.$t('tools.toolIsReservedByAndInCar') + ' ' + this.employee
        confirmationMessage = this.$t('tools.toolWillBeUnreservedAndRemovedFromCar')
        needsBoth = true
      }
      if(needsUserConfirmation === false)
      {
        this.changeStatus(status)
      }
      else
      {
        if (this.userRole === 'User') {
          this.$toast.info(this.$t('common.unableToUpdate') + ": " + confirmationTitle, { timeout: 2000 });
        }
        else {
          swal.fire({
            title: confirmationTitle,
            text: confirmationMessage,
            icon: 'warning',
            showCancelButton: true,
            customClass: {
              confirmButton: 'btn btn-success btn-fill',
              cancelButton: 'btn btn-danger btn-fill'
            },
            confirmButtonText: this.$t('common.continue'),
            cancelButtonText: this.$t('delete.cancel'),
            buttonsStyling: false
          }).then(result => {
            if (result.value) {
              let UnreserveOverUrl = `/Tool/Unreserve/${this.tool.id}`
              let removeFromCarUrl = `/ToolGroup/RemoveTool/`
              let removeFromCarBody = {
                  toolGroupId: this.carId,
                  toolId: this.tool.id
              }
              if(needsBoth === true)
              {
                api.put(UnreserveOverUrl).then(() => {
                  api.put(removeFromCarUrl,removeFromCarBody).then(() => {
                    this.changeStatus(status)
                  })
                  .catch(error => {
                    console.error('API request error:', error); // eslint-disable-line no-console
                    this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
                  });
                })
                .catch(error => {
                  console.error('API request error:', error); // eslint-disable-line no-console
                  this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
                });
              }
              else if(removeFromCar === true)
              {
                api.put(removeFromCarUrl,removeFromCarBody).then(() => {
                  this.changeStatus(status)
                })
                  .catch(error => {
                  console.error('API request error:', error); // eslint-disable-line no-console
                  this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
                });
              }
              else if(needsUnreserve === true)
              {
                api.put(UnreserveOverUrl).then(() => {
                  this.changeStatus(status)
                })
                  .catch(error => {
                  console.error('API request error:', error); // eslint-disable-line no-console
                  this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
                });
              }
            }
            else{
              return;
            }
          });
        }
      }
    },
    cancelNewToolType(){
      if(this.toolTypeOptions.length>0){
        this.toolTypeOption = this.toolTypeOptions[0].type
      }
      else{
        this.toolTypeOption = ''
      }
    },
    async returnTool(){
      if(this.tool.multiTool)
      {
        this.showReturnMultiToolModal = true
        return;
      }
      const result = await swal.fire({
        title: this.$t('tools.areYouSureReturn'),
        icon: 'warning',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-success btn-fill',
          cancelButton: 'btn btn-danger btn-fill'
        },
        confirmButtonText: this.$t('tools.yesReturnIt'),
        cancelButtonText: this.$t('delete.cancel'),
        buttonsStyling: false
      });
      if (result.isConfirmed) {
        if (this.enableToolPriceTypes && this.toolPriceTypeOption !== 1) {
          this.showUnitInputModal = true;
        }
        else {
          this.unreserveTool(null);
        }
      }
    },
    async handleUnitInput() {
      // Convert comma to dot for decimal validation
      const processedUnits = this.units !== null ? this.units.toString().replace(',', '.') : -1;
      // Regular expression to check for valid numbers (integers or decimals)
      const isValidNumber = /^\d+(\.\d+)?$/.test(processedUnits);
      if (isValidNumber) {
        let requestBody = {units: processedUnits};
        this.showUnitInputModal = false;
        if(this.tool.multiTool) {
          if(this.multiToolIdsToExternalReturn.length > 0)
          {
            let ids = this.multiToolIdsToExternalReturn.join(',');
            await api.put(`/Tool/UnreserveByIds/External`,{ids: ids, units: processedUnits});
          }
          if(this.multiToolIdsToReturn.length > 0)
          {
            let ids = this.multiToolIdsToReturn.join(',');
            await api.put(`/Tool/UnreserveByIds`,{ids: ids, units: processedUnits});
          }
          this.units = null;
          this.$toast.success(this.$t('tools.toolReturned'), { timeout: 1500 });
          this.fetchData();
        }
        else {
          this.unreserveTool(requestBody);
        }
      }
      else {
        this.$toast.danger(this.$t('errors.unitCountEmpty'), { timeout: 1500 });
      }
    },
    async unreserveTool(requestBody) {
      let unreserveUrl = this.isReserved
        ? `/Tool/Unreserve/${this.toolId}`
        : `/Tool/Unreserve/External/${this.toolId}`;
      const isExternalReturn = !this.isReserved;
      let standardFlow = requestBody !== null ? false : true;
      requestBody = requestBody || {}; // Default to an empty object if requestBody is null
      try {
        const response = await api.put(unreserveUrl, requestBody);
        //Check if user wants to update reservation days IF this is a rent (not loan):
        this.units = null;
        this.externalToolReservationImageUpload = isExternalReturn;
        this.fetchData();
        if(response.data.totalPrice && response.data.totalPrice>0) {
          this.latestUnreservedId = response.data.id
          let totalDays = this.calculateDays(response.data.reservedTimestamp, response.data.unreservedTimestamp);
          if (standardFlow) {
            const result = await swal.fire({
              title: this.$t('tools.successfulUnreserve'),
              text: `${this.$t('tools.youHadToolFor')} ${totalDays} ${this.$t('tools.daysPrice')} ${response.data.totalPrice} Kr.`,
              icon: 'success',
              showCancelButton: true,
              customClass: {
                confirmButton: 'btn btn-success btn-fill',
                cancelButton: 'btn btn-danger btn-fill'
              },
              confirmButtonText: this.$t('tools.acceptTotalPrice'),
              cancelButtonText: this.$t('tools.updateReservedDays'),
              buttonsStyling: false
            });
            if (!result.isConfirmed) {
              this.updatedReservationDate = this.formatDateResponse(response.data.reservedTimestamp);
              this.updatedUnreservationDate = this.formatDateResponse(response.data.unreservedTimestamp);
              if (standardFlow) {
                this.showUpdateReservationDaysModal = true;
              }
            }
            else {
              await swal.fire({
                title: this.$t('tools.returned'),
                text: `${this.$t('tools.youReturned')} ${this.tool.name}`,
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-success btn-fill',
                },
                buttonsStyling: false
              });
              if (this.checkIfImageUploadIsRequired(response.data.reservedTimestamp, response.data.unreservedTimestamp, response.data.tool ?? this.tool)) {
                this.showImageUpload = true;
              }
            }
          }
          else {
            await swal.fire({
              title: this.$t('tools.returned'),
              text: `${this.$t('tools.youReturned')} ${this.tool.name} ${this.$t('tools.daysPrice')} ${response.data.totalPrice} Kr.`,
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-success btn-fill',
              },
              buttonsStyling: false
            });
            if (this.checkIfImageUploadIsRequired(response.data.reservedTimestamp, response.data.unreservedTimestamp, response.data.tool ?? this.tool)) {
              this.showImageUpload = true;
            }
          }
        }
        else{
          this.latestUnreservedId = response.data.id;
          await swal.fire({
            title: this.$t('tools.returned'),
            text: `${this.$t('tools.youReturned')} ${this.tool.name}`,
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-success btn-fill',
            },
            buttonsStyling: false
          });
          if (this.checkIfImageUploadIsRequired(response.data.reservedTimestamp, response.data.unreservedTimestamp, response.data.tool ?? this.tool)) {
            this.showImageUpload = true;
          }
        }
      } catch (error) {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.danger(`${this.$t('tools.toolReturnError')}: ${error.message}`, { timeout: 0 });
        }
    },
    formatDateResponse(dateString) {
      const date = new Date(dateString);
      return date.toISOString().slice(0, 10);
    },
    async startReserveByButton() {
      this.showProjectPickModal = true;
    },
    async onProjectConfirmed(selection) {
      this.selectedProject = selection.projectId;
      this.selectedProjectPhase = selection.phaseId;
      if (this.allowAssigningToolToOtherUser) {
        this.showProjectPickModal = false;
        this.selectedUser = this.userId;
        await this.fetchUserTableData();
        this.showUserPickModal = true;
      } else {
        this.reserveTool();
      }
    },
    async fetchUserTableData() {
      let userUrl = this.userSearchQuery === ''
        ? `/User?currentPage=${this.usersPagination.currentPage}&pageSize=${this.usersPagination.perPage}&excludeImages=true`
        : `/User?currentPage=${this.usersPagination.currentPage}&pageSize=${this.usersPagination.perPage}&name=${this.userSearchQuery}&excludeImages=true`;
      try {
        const response = await api.get(userUrl);
        this.usersPagination.total = response.data.totalItems;
        this.usersForPick = response.data.result.map(item => ({ id: item.id, name: item.firstName + ' ' + item.lastName, email: item.email }));
      } catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.error(this.$t('common.unableToRetrieveData'), { timeout: 0 });
      }
    },
    searchUsers() {
      this.usersPagination.currentPage = 1;
      this.fetchUserTableData();
    },
    handleClearSearchUsers() {
      this.userSearchQuery = '';
      this.fetchUserTableData();
    },
    updateUserPage(page) {
      this.usersPagination.currentPage = page;
      this.fetchUserTableData();
    },
    async reserveTool() {
      if (this.selectedProject === null) {
        this.$toast.error(this.$t('tools.pickProject'), { timeout: 2000 });
        return;
      }
      if (this.allowAssigningToolToOtherUser && this.selectedUser === null) {
        this.$toast.error(this.$t('tools.pickUser'), { timeout: 2000 });
        return;
      }
      try {
        const body = { toolId: this.tool.id, projectId: this.selectedProject };
        if (this.selectedProjectPhase) {
          body.projectPhaseId = this.selectedProjectPhase;
        }
        if (this.allowAssigningToolToOtherUser && this.selectedUser) {
          body.userId = this.selectedUser;
        }
        await api.post('/Tool/Reserve', body);
        this.$toast.success(this.$t('tools.toolReserved'), { timeout: 1500 });
        this.fetchData();
        this.showProjectPickModal = false;
        this.showUserPickModal = false;
        this.selectedProject = null;
        this.selectedProjectPhase = null;
        this.selectedUser = null;
        this.userSearchQuery = '';
        this.usersPagination = { perPage: 5, currentPage: 1, total: 0 };
      } catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.error(this.$t('tools.unableToReserveTool'), { timeout: 2000 });
      }
    },
    openRentLoanForm(){
      this.showRentLoanForm = true;
      window.scrollTo(0,0);
    },
    closeRentLoanForm(){
      this.showRentLoanForm = false;
    },
    setUpdateStatusOptions(){
      if(this.toolStatus === this.$t('toolStatus.free') || this.toolStatus === this.$t('toolStatus.inUse') ){
        this.updateToolStatusOptions = [{id: 3, status: this.$t('toolStatus.broken'), loading: false, icon: 'tim-icons icon-simple-delete', color:'orange' }, {id: 4, status: this.$t('toolStatus.outOfUse'), loading: false, icon: 'tim-icons icon-simple-remove', color:'orange' }]
      }
      else if(this.toolStatus === this.$t('toolStatus.broken')){
        this.updateToolStatusOptions = [{id: 1, status: this.$t('toolStatus.free'), loading: false, icon: 'tim-icons icon-triangle-right-17', color:'green' }, {id: 4, status: this.$t('toolStatus.outOfUse'), loading: false, icon: 'tim-icons icon-simple-remove', color:'orange' }]
      }
      else if(this.toolStatus === this.$t('toolStatus.outOfUse')){
        this.updateToolStatusOptions = [{id: 1, status: this.$t('toolStatus.free'), loading: false, icon: 'tim-icons icon-triangle-right-17', color:'green' }, {id: 3, status: this.$t('toolStatus.broken'), loading: false, icon: 'tim-icons icon-simple-delete', color:'orange' }]
      }
      else
      {
        this.updateToolStatusOptions = []
      }
    },
    async fetchData() {
      let toolUrl = `/Tool/${this.toolId}`;
      try {
        const response = await api.get(toolUrl);
        //This is a bit of a hack to store the original value by deep copying the response.data
        this.tool = JSON.parse(JSON.stringify(response.data));
        this.purchaseDateGoodFormat = this.tool.purchaseDate ? this.tool.purchaseDate.split('T')[0] : '';
        this.toolStatus = this.getStatusTranslation(this.tool.toolStatusId)
        this.updatedStatus = this.toolStatus
        this.onCreatedTool = JSON.parse(JSON.stringify(response.data));
        this.locationOption = this.tool.location.address
        this.toolTypeOption = this.tool.toolType.type
        this.toolInUse = this.tool.inUse ? this.tool.inUse: 0
        if(this.tool.multiTool)
        {
          this.toolsAvailable = this.tool.totalCount - this.tool.inUse

          let externalReservations = []
          if(this.userRole !== 'User')
          {
            externalReservations = this.tool.externalToolReservations
              .map(item => {
                return {
                  id: item.id,
                  quantity: item.quantity,
                  reservationDate: new Date(item.reservedTimestamp).toLocaleDateString('is-IS'),
                  project: item.project !== null ? item.project.name + (item.projectPhaseName ? ' — ' + item.projectPhaseName : '') : null,
                  type: this.$t('tools.loanedRented'),
                  user: item.user.firstName + ' ' + item.user.lastName
                };
              });
          }

          let reservations = []
          if(this.allowToolReservaAndUnreserveWithourQRScan)
          {
            reservations = this.tool.toolReservations
              .map(item => {
                return {
                  id: item.id,
                  quantity: item.quantity,
                  reservationDate: new Date(item.reservedTimestamp).toLocaleDateString('is-IS'),
                  project: item.project !== null ? item.project.name + (item.projectPhaseName ? ' — ' + item.projectPhaseName : '') : null,
                  type: this.$t('tools.reserved'),
                  user: item.user.firstName + ' ' + item.user.lastName
                };
              });
          }
          this.multiToolReturnTable = reservations.concat(externalReservations)
        }
        this.toolPriceTypeLabel = this.formatToolPriceType(this.tool.toolPriceTypeId);
        this.setMaxReservationDisplayValue();
        this.setToolInfo();
        this.setUpdateStatusOptions();
        this.toolDisplayName = `#${this.tool.customerToolId} ${this.tool.name}`;
        if(this.tool.toolQRCodeBanner !== null)
        {
          this.showQRBannerUpload = true
        }
        this.toolDataLoaded = true;
        
        // Fetch revenue stats after tool data is loaded (needs tool.purchasePrice)
        if (this.userRole !== 'User') {
          this.fetchRevenueStats();
        }

        if(this.loanRentCustomer)
        {
          if(this.tool.multiTool)
          {
            this.initTable(2)
          }
          else
          {
            this.initTable(1)
          }
        }
        else
        {
          this.initTable(0)
        }
      } catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
      }
      //fetch tooltypes and locations
      let getToolTypesUrl = `/ToolType`
      try {
        const response = await api.get(getToolTypesUrl);
        this.toolTypeOptions = response.data;
      } catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
      }
      let getLocationsUrl = `/Location?pageSize=100`
      try {
        const response = await api.get(getLocationsUrl);
        this.locationOptions = response.data.result;
      } catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
      }
      try {
        const customer = await loadCustomerMeCached();
        this.customerCustomQRBanner = customer.toolLogoBytes
      } catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
      }
    },
    setMaxReservationDisplayValue(){
      if(this.tool.maxReservationDays && this.tool.maxReservationDays !== 0){
        this.maxReservationDaysDisplayValue = this.tool.maxReservationDays
      }
      else{
        this.maxReservationDaysDisplayValue = '∞'
      }
    },
    setToolInfo()
    {
      if(this.tool.toolReservations.length>0)
      {
        this.employee = this.tool.toolReservations[0].user.firstName + ' ' + this.tool.toolReservations[0].user.lastName
        this.employeeId = this.tool.toolReservations[0].user.id;
        this.reservedTimestamp = this.tool.toolReservations[0].reservedTimestamp.split('T')[0]
        this.projectName = this.tool.toolReservations[0].project.name
        this.projectId = this.tool.toolReservations[0].project.id;
        this.isReserved = true;
      }
      else if(this.tool.externalToolReservations.length>0)
      {
        this.employee = this.tool.externalToolReservations[0].user.firstName + ' ' + this.tool.externalToolReservations[0].user.lastName
        this.employeeId = this.tool.externalToolReservations[0].user.id;
        this.reservedTimestamp = this.tool.externalToolReservations[0].reservedTimestamp.split('T')[0]
        this. externalUserLoanRent = this.tool.externalToolReservations[0].externalUser
        if(this.tool.externalToolReservations[0].project){
          this.projectName = this.tool.externalToolReservations[0].project.name;
          this.projectId = this.tool.externalToolReservations[0].project.id;
        }
        this.isExternalReserved = true;
      }
      else{
        this.isReserved = false
        this.isExternalReserved = false
        this.employee = ""
        this.reservedTimestamp = ""
        this.projectName = ""
        this. externalUserLoanRent = ""
      }
      if(this.tool.toolToToolGroup && this.tool.toolToToolGroup !== null){
        this.car = this.tool.toolToToolGroup.toolGroup.name;
        this.carId = this.tool.toolToToolGroup.toolGroup.id;
      }
     else{
        this.car = ''
        this.carId = ''
      }
    },
    printQRCode() {
      if (this.isMobile) {
        return;
      }

      let pageWidth, pageHeight, qrSize, logoWidth, logoHeight, fontSize, padding, logoMarginBottom;

      switch (this.selectedLabelSize) {
        case '2x2':
          pageWidth = '2in'; pageHeight = '2in'; qrSize = '1.5in';
          logoWidth = '1.2in'; logoHeight = '0.3in'; fontSize = '0.12in';
          padding = '0.03in'; logoMarginBottom = '0.03in';
          break;
        case '3x2':
          pageWidth = '3in'; pageHeight = '2in'; qrSize = '1.7in';
          logoWidth = '1.5in'; logoHeight = '0.4in'; fontSize = '0.15in';
          padding = '0.03in'; logoMarginBottom = '0.03in';
          break;
        case '3x3':
          pageWidth = '3in'; pageHeight = '3in'; qrSize = '2.5in';
          logoWidth = '2in'; logoHeight = '0.5in'; fontSize = '0.2in';
          padding = '0.05in'; logoMarginBottom = '0.05in';
          break;
        case '4x4':
          pageWidth = '4in'; pageHeight = '4in'; qrSize = '3in';
          logoWidth = '2.5in'; logoHeight = '0.6in'; fontSize = '0.25in';
          padding = '0.05in'; logoMarginBottom = '0.05in';
          break;
        case '1x1':
        default:
          pageWidth = '1in'; pageHeight = '1in'; qrSize = '0.8in';
          logoWidth = '0in'; logoHeight = '0in'; fontSize = '0.1in';
          padding = '0.02in'; logoMarginBottom = '0in';
          break;
      }

      const truncatedName = this.toolDisplayName.length > 20
        ? this.toolDisplayName.substring(0, 17) + '...'
        : this.toolDisplayName;

      const logoSrc = this.qrCodeBanner;
      const is1x1 = this.selectedLabelSize === '1x1';
      const printScript = is1x1 ? '<script>window.print();<' + '/script>' : '';

      const printWindow = window.open('', '_blank');
      printWindow.document.write(`
        <html>
          <head>
            <title>Print QR Code</title>
            <style>
              @page {
                size: ${pageWidth} ${pageHeight};
                margin: 0;
              }
              body, html {
                margin: 0;
                padding: 0;
                width: ${pageWidth};
                height: ${pageHeight};
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
              }
              .qr-print-container {
                width: ${pageWidth};
                height: ${pageHeight};
                display: flex;
                flex-direction: column;
                justify-content: ${is1x1 ? 'center' : 'flex-start'};
                align-items: center;
                background: #ffffff;
                box-sizing: border-box;
                padding: ${padding};
              }
              .print-logo {
                width: ${logoWidth};
                height: auto;
                max-height: ${logoHeight};
                margin-bottom: ${logoMarginBottom};
                display: ${is1x1 ? 'none' : 'block'};
                object-fit: contain;
              }
              .qrcode-vue {
                width: ${qrSize};
                height: ${qrSize};
                max-width: ${qrSize};
                max-height: ${qrSize};
                object-fit: contain;
                margin-bottom: ${is1x1 ? '0.02in' : '0'};
              }
              h3 {
                color: black;
                font-weight: bold;
                font-size: ${fontSize};
                margin: 0;
                text-align: center;
                max-width: calc(${pageWidth} - ${padding} * 2);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            </style>
          </head>
          <body>
            <div class="qr-print-container">
              ${!is1x1 ? `<img src="${logoSrc}" alt="app-logo" class="print-logo" onload="window.print()" onerror="console.error('Logo failed to load');"/>` : ''}
              <svg class="qrcode-vue" width="${qrSize}" height="${qrSize}" viewBox="${this.$refs.printqrcode.$el.getAttribute('viewBox')}">${this.$refs.printqrcode.$el.innerHTML}</svg>
              <h3>${truncatedName}</h3>
            </div>
            ${printScript}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.addEventListener('afterprint', () => printWindow.close());
    },
    saveLabelSize() {
      localStorage.setItem('labelSize', this.selectedLabelSize);
    },
    handleEdit() {
      window.scrollTo(0, 0);
      let getToolTypesUrl = `/ToolType`
      api.get(getToolTypesUrl)
      .then(response => {
          this.toolTypeOptions = response.data;
      })
      .catch(error => {
          console.error('API request error:', error); // eslint-disable-line no-console
      });
      let getLocationsUrl = `/Location?pageSize=100`
      api.get(getLocationsUrl)
      .then(response => {
          this.locationOptions = response.data.result;
      })
      .catch(error => {
          console.error('API request error:', error); // eslint-disable-line no-console
      });
      this.enableEdit = true;
    },
    handleDuplicate() {
      window.scrollTo(0, 0);
      this.showDuplicateForm = true;
    },
    navigateToDuplicatedTool(toolData) {
      const toolId = toolData.id || toolData;
      this.$router.push({ name: 'Tool', params: { toolId: toolId } });
    },
    async handleUpdate() {
      if (this.validateInput()) {
        let updateUrl = `/Tool/${this.toolId}`
        if(this.newToolType !== '') {
          try {
            const response = await api.post('/ToolType', { type: this.newToolType });
            this.tool.toolTypeId = response.data.id;
            this.toolTypeOption = response.data.type;
          } catch (error) {
            console.error('API request error:', error); // eslint-disable-line no-console
            this.$toast.danger(`${this.$t('common.unableToUpdate')} ${this.tool.name}`, { timeout: 2000 });
          }
        }
        else {
          this.tool.toolTypeId = this.toolTypeOptions.filter(op => op.type === this.toolTypeOption)[0].id;
        }
        this.tool.locationId = this.locationOptions.filter(op => op.address === this.locationOption)[0].id;
        this.tool.toolPriceTypeId = this.toolPriceTypeOption;
        if(this.updatedStatus !== this.toolStatus)
        {
          if(this.updateToolStatusOptions.filter(op => op.status === this.updatedStatus).length > 0)
          {
            this.tool.toolStatusId = this.updateToolStatusOptions.filter(op => op.status === this.updatedStatus)[0].id;
          }
        }
        if(this.tool.totalCount === '')
        {
          this.tool.totalCount = 0
        }
        try {
          const response = await api.put(updateUrl, this.tool);
          this.tool = JSON.parse(JSON.stringify(response.data));
          this.purchaseDateGoodFormat = response.data.purchaseDate ? response.data.purchaseDate.split('T')[0] : '';
          this.toolStatus = this.getStatusTranslation(response.data.toolStatusId);
          this.toolPriceTypeLabel = this.formatToolPriceType(this.tool.toolPriceTypeId);
          this.setUpdateStatusOptions()
          this.setMaxReservationDisplayValue();
          this.setToolInfo();
          this.$toast.success(`${this.tool.name} ${this.$t('common.updated')}`, { timeout: 2000 });
          this.enableEdit = false;
        } catch (error) {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.danger(`${this.$t('common.unableToUpdate')} ${this.tool.name}`, { timeout: 2000 });
        }
      }
    },
    validateInput() {
      let success = true;
      if (this.tool.name === '') {
        this.$refs.nameInput.focus();
        this.$toast.info(this.$t('errors.nameEmpty'), { timeout: 2500 });
        success = false;
      }
      else if (this.tool.description === '') {
        this.$refs.descriptionInput.focus();
        this.$toast.info(this.$t('errors.descriptionEmpty'), { timeout: 2500 });
        success = false;
      }
      else if (this.tool.toolImageBytes === '') {
        this.$toast.info(this.$t('errors.imageEmpty'), { timeout: 2500 });
        success = false;
      }
      else if (this.locationOption === '') {
        this.$refs.locationTypeInput.focus();
        this.$toast.info(this.$t('errors.locationEmpty'), { timeout: 2500 });
        success = false;
      }
      else if (this.toolTypeOption === 'New Type' && this.newToolType === '') {
        this.$refs.newToolTypeInput.focus();
        this.$toast.info(this.$t('errors.newToolTypeEmpty'), { timeout: 2500 });
        success = false;
      }
      else if (this.tool.multiTool && (this.tool.totalCount === 0 || this.tool.totalCount === '' || !this.checkIfNumber(this.tool.totalCount))) {
        this.$refs.totalCountInput.focus();
        this.$toast.info(this.$t('errors.totalCountEmpty'), { timeout: 2500 });
        success = false;
      }
      else if (this.toolTypeOption === '') {
        this.$refs.toolTypeInput.focus();
        this.$toast.info(this.$t('errors.toolTypeEmpty'), { timeout: 2500 });
        success = false;
      }
      else if (this.tool.inUse > this.tool.totalCount) {
        this.$refs.totalCountInput.focus();
        this.$toast.info(this.$t('errors.totalCountExceedsInUse'), { timeout: 2500 });
        success = false;
      }
      return success;
    },
    handleCancel() {
      this.enableEdit = false;
      this.tool = this.onCreatedTool;
    },
    async handleDelete(){
      const result = await swal.fire({
        title: this.$t('delete.areYouSure'),
        text: this.$t('delete.noRevert'),
        icon: 'warning',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-success btn-fill',
          cancelButton: 'btn btn-danger btn-fill'
        },
        confirmButtonText: this.$t('delete.yesDeleteIt'),
        cancelButtonText: this.$t('delete.cancel'),
        buttonsStyling: false
      });
      if (result.isConfirmed) {
        this.deleteTool();
      }
    },
    async deleteTool() {
        let deleteUrl = `/Tool/${this.toolId}`
        try {
          await api.delete(deleteUrl);
          await swal.fire({
            title: this.$t('delete.deleted'),
            text: `${this.$t('delete.youDeleted')} ${this.tool.name}`,
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-success btn-fill',
            },
            buttonsStyling: false
          });
          this.goToTools();
        } catch (error) {
          console.error('API request error:', error); // eslint-disable-line no-console
          await swal.fire({
            title: this.$t('common.somethingWentWrong'),
            text: `${this.$t('common.unableToDelete')} ${this.tool.name}`,
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success btn-fill',
            },
            buttonsStyling: false
          });
        }
    },
    handleFileUpload(file) {
      if(file){
        const reader = new FileReader();
        reader.onloadend = () => {
          let binary = '';
          const bytes = new Uint8Array(reader.result);
          bytes.forEach((byte) => binary += String.fromCharCode(byte));
          this.tool.toolImageBytes = btoa(binary);
        };
        reader.readAsArrayBuffer(file);
      }
      else{
        this.tool.toolImageBytes = this.onCreatedTool.toolImageBytes
      }
    },
    handleQRBannerFileUpload(file)
    {
      if(file){
        const reader = new FileReader();
        reader.onloadend = () => {
          let binary = '';
          const bytes = new Uint8Array(reader.result);
          bytes.forEach((byte) => binary += String.fromCharCode(byte));
          this.tool.toolQRCodeBanner = btoa(binary);
        };
        reader.readAsArrayBuffer(file);
      }
      else{
        this.tool.toolQRCodeBanner = this.onCreatedTool.toolQRCodeBanner
      }
    },
    checkIfNumber(input) {
      if (!isNaN(input)) {
        return true
      } else {
        return false
      }
    },
    goToTools() {
      this.$router.push({ name: 'Tools' });
    },
    goToCar() {
      this.$router.push({ name: 'Car', params: { toolGroupId: this.carId } });
    },
    goToProject() {
      this.$router.push({ name: 'Project', params: { projectId: this.projectId } });
    },
    goToUser() {
      if(this.userRole !== 'User' || this.userId === this.employeeId) {
        this.$router.push({ name: 'User Profile Page', params: { userId: this.employeeId } });
      }
      else {
        this.$router.push({ name: 'User', params: { userId: this.employeeId } });
      }
    },
    formatToolPriceType(id) {
      var option = this.toolPriceTypeOptions.find(option => option.id === id);
      this.toolPriceTypePlaceholder = option.type;
      this.toolPriceTypeOption = option.id;
return option.type.toLowerCase();
},
    getStatusTranslation(statusId)
    {
       switch (statusId) {
            case 1:
              return this.$t('toolStatus.free')
            case 2:
              return this.$t('toolStatus.inUse')
            case 3:
              return this.$t('toolStatus.broken')
            case 4:
              return this.$t('toolStatus.outOfUse')
            case 5:
              return this.$t('toolStatus.loaned')
            case 6:
              return this.$t('toolStatus.rented')
            case 7:
              return this.$t('toolStatus.partlyUsed')
            case 8:
              return this.$t('toolStatus.fullyUsed')
            default:
              return 'N/A'
          }
    },
    calculateDays(date1, date2) {
      const startDate = new Date(date1);
      const endDate = new Date(date2);
      // Normalize the dates to midnight (00:00:00)
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);
      // Calculate the difference in time (milliseconds)
      const timeDiff = endDate.getTime() - startDate.getTime();
      // Calculate the total number of days
      const totalDays = timeDiff / (1000 * 3600 * 24) + 1;
      // Round up to the nearest whole day
      return Math.ceil(totalDays);
    },
    isValidDate(dateString) {
      const date = new Date(dateString);
      return date instanceof Date && !isNaN(date);
    },
    updateReservationDataIsValid() {
      if (this.updatedReservationDate === null || this.updatedReservationDate === '' || this.updatedUnreservationDate === null || this.updatedUnreservationDate === '') {
        this.$toast.danger(this.$t('errors.datesEmptyOrIncorrect'), { timeout: 0 });
        return false;
      }
      if (!this.isValidDate(this.updatedReservationDate) || !this.isValidDate(this.updatedUnreservationDate)) {
        this.$toast.danger(this.$t('errors.datesEmptyOrIncorrect'), { timeout: 0 });
        return false;
      }
      if (new Date(this.updatedReservationDate) > new Date(this.updatedUnreservationDate)) {
        this.$toast.danger(this.$t('errors.startDateBiggerThanEndDate'), { timeout: 0 });
        return false;
      }
      return true;
    },
    async updateReservationDays(){
      if (!this.updateReservationDataIsValid()) {
        return;
      }
      const reservedTimestamp = this.updatedReservationDate;
      const unreservedTimestamp = this.updatedUnreservationDate;
      var requestBody = this.setPriceZero ?
          {updatedReservedTimestamp: reservedTimestamp, updatedUnreservedTimestamp: unreservedTimestamp, totalPrice: 0} :
          {updatedReservedTimestamp: reservedTimestamp, updatedUnreservedTimestamp: unreservedTimestamp};
      try {
        const response = await api.put(`/Tool/Reservation/External/${this.latestUnreservedId}`, requestBody);
        this.showUpdateReservationDaysModal = false;
        this.updatedReservationDate = null;
        this.updatedUnreservationDate = null;
        this.setPriceZero = false;
        await swal.fire({
          title: `${this.$t('tools.updatedPrice')} ${response.data.totalPrice} Kr.`,
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-success btn-fill',
          },
          buttonsStyling: false
        });
        if (this.checkIfImageUploadIsRequired(reservedTimestamp, unreservedTimestamp, this.tool)) {
          this.showImageUpload = true;
        }
      } catch (error) {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.danger(`${this.$t('tools.toolReturnError')}: ${error.message}`, { timeout: 0 });
        }
    },
    initTable(index) {
      this.activeIndex = index;
      this.tableDataReady = false;
      this.fetchNewData();
    },
    updatePagination(item) {
      this.pagination.currentPage = item;
      this.fetchNewData();
    },
    changePage(page) {
      if (page !== this.pagination.currentPage && page >= 1 && page <= this.totalPages) {
        this.pagination.currentPage = page;
        this.fetchNewData();
      }
    },
    nextPage() {
      if (this.pagination.currentPage < this.totalPages) {
        this.changePage(this.pagination.currentPage + 1);
      }
    },
    prevPage() {
      if (this.pagination.currentPage > 1) {
        this.changePage(this.pagination.currentPage - 1);
      }
    },
    async fetchNewData() {
      if(this.tool.multiTool)
      {
        if (this.activeIndex === 0) {
          this.cardTitle = this.$t('tools.inUse');
          this.activeEntity = 'ToolsInUse';
          await this.fetchMultiToolInUseTable();
        }
        else if (this.activeIndex === 1) {
          this.cardTitle = this.$t('projects.reservationHistory');
          this.activeEntity = 'ToolReservation';
          await this.fetchHistoryTableData();
        }
        else if (this.activeIndex === 2) {
          this.cardTitle = this.$t('projects.loanRentHistory');
          this.activeEntity = 'ExternalReservation';
          await this.fetchLoanRentHistoryTableData();
        }
        else if (this.activeIndex === 3) {
          this.cardTitle = this.$t('repairLog.repairHistory');
          this.activeEntity = 'RepairLog';
          await this.fetchRepairHistoryTableData();
        }
        else if (this.activeIndex === 4) {
          this.cardTitle = this.$t('tools.toolReminders');
          this.activeEntity = 'Reminders';
        }
      }
      else
      {
        if (this.activeIndex === 0) {
          this.cardTitle = this.$t('projects.reservationHistory');
          this.activeEntity = 'ToolReservation';
          await this.fetchHistoryTableData();
        }
        else if (this.activeIndex === 1) {
          this.cardTitle = this.$t('projects.loanRentHistory');
          this.activeEntity = 'ExternalReservation';
          await this.fetchLoanRentHistoryTableData();
        }
        else if (this.activeIndex === 2) {
          this.cardTitle = this.$t('repairLog.repairHistory');
          this.activeEntity = 'RepairLog';
          await this.fetchRepairHistoryTableData();
        }
        else if (this.activeIndex === 3) {
          this.cardTitle = this.$t('tools.toolReminders');
          this.activeEntity = 'Reminders';
        }
      }
      this.initialTableReady = true
    },
    async returnMultiTool()
    {
      if(this.multiToolIdsToExternalReturn.length === 0 && this.multiToolIdsToReturn.length === 0)
      {
        this.$toast.danger(this.$t('errors.nothingSelected'), { timeout: 0 });
        return
      }

      if (this.enableToolPriceTypes && this.toolPriceTypeOption !== 1) {
        this.showReturnMultiToolModal = false;
        this.showUnitInputModal = true;
      }
      else {
        if(this.multiToolIdsToExternalReturn.length > 0)
        {
          let ids = this.multiToolIdsToExternalReturn.join(',');
          await api.put(`/Tool/UnreserveByIds/External`,{ids: ids});
        }
        if(this.multiToolIdsToReturn.length > 0)
        {
          let ids = this.multiToolIdsToReturn.join(',');
          await api.put(`/Tool/UnreserveByIds`,{ids: ids});
        }
        this.showReturnMultiToolModal = false;
        this.multiToolIdsToReturn = [];
        this.multiToolIdsToExternalReturn = [];
        this.selectedMultiToolsToReturnRows = {};
        this.$toast.success(this.$t('tools.toolReturned'), { timeout: 1500 });
        this.fetchData();
      }
    },
    handleSelection(row, checked) {
      this.selectedMultiToolsToReturnRows[row.id] = checked;
      if (checked)
      {
        if(row.type === this.$t('tools.reserved'))
        {
          if (!this.multiToolIdsToReturn.includes(row.id))
          {
            this.multiToolIdsToReturn.push(row.id);
          }
        }
        else
        {
          if (!this.multiToolIdsToExternalReturn.includes(row.id))
          {
            this.multiToolIdsToExternalReturn.push(row.id);
          }
        }
      }
      else
      {
        if(row.type === this.$t('tools.reserved'))
        {
          this.multiToolIdsToReturn = this.multiToolIdsToReturn.filter(item => item !== row.id);
        }
        else
        {
          this.multiToolIdsToExternalReturn = this.multiToolIdsToExternalReturn.filter(item => item !== row.id);
        }
      }
    },
    // Inserts a phase column before the mobile compound column when phases are enabled.
    addPhaseColumn(columns) {
      if (!this.enableProjectPhases) return;
      const compoundIndex = columns.findIndex(c => c.isCompound);
      if (compoundIndex !== -1) columns[compoundIndex].compound['projects.phase'] = 'phase';
      columns.splice(compoundIndex === -1 ? columns.length : compoundIndex, 0, { prop: 'phase', label: this.$t('projects.phase'), minWidth: 110 });
    },
    async fetchMultiToolInUseTable()
    {
      let toolReserveUrl = `/Tool/Reservations?currentPage=1&pageSize=1000&toolId=${this.toolId}&unreserved=false&orderByReservedTimestamp=false&orderByDescending=true&excludeImages=true`;
      let externalReserveUrl = `/Tool/Reservations/External?currentPage=1&pageSize=1000&toolId=${this.toolId}&unreserved=false&orderByReservedTimestamp=false&orderByDescending=true&excludeImages=true`;
      this.tableData = {
        title: this.$t('projects.reservationHistory'),
        columns: [
          { prop: 'type', label: this.$t('toolGroups.reservationType'), minWidth: 150},
          { prop: 'reserved by', label: this.$t('tools.reservedBy'), minWidth: 200},
          { prop: 'project', label: this.$t('common.project'), minWidth: 100 },
          { prop: 'reserved', label: this.$t('tools.reserved'), minWidth: 100 },
          { prop: 'quantity', label: this.$t('tools.quantity'), minWidth: 120 },
          { label: this.$t('common.info'), minWidth: 150, showOnMobile: true, isCompound: true, compound: { 'toolGroups.reservationType': 'type', 'tools.reservedBy': 'reserved by', 'common.project': 'project', 'tools.reserved': 'reserved','tools.quantity': 'quantity'}},
        ],
        data: [],
      }
      this.addPhaseColumn(this.tableData.columns);
      try {
        const [reservationResponse, externalResponse] = await Promise.all([
          api.get(toolReserveUrl),
          api.get(externalReserveUrl)
        ]);

        const reservations = reservationResponse.data.result.map(item => {
          return {
            'reserved': new Date(item.reservedTimestamp).toLocaleDateString('is-IS'),
            'reserved by': item.user.firstName + " " + item.user.lastName,
            id: item.id,
            project: item.project.name,
            phase: item.projectPhaseName || '',
            quantity: item.quantity,
            type: this.$t('tools.reserved')
          };
        });

        const externalReservations = externalResponse.data.result.map(item => {
          return {
            'reserved': new Date(item.reservedTimestamp).toLocaleDateString('is-IS'),
            'reserved by': item.rented
              ? this.$t('tools.rented') + " - " + item.externalUser
              : this.$t('tools.loaned') + " - " + item.externalUser,
            id: item.id,
            project: item.project !== null ? item.project.name : '',
            phase: item.projectPhaseName || '',
            quantity: item.quantity,
            type: this.$t('tools.loanedRented')
          };
        });

        const allData = reservations.concat(externalReservations);
        this.pagination.total = allData.length;
        const start = (this.pagination.currentPage - 1) * this.pagination.perPage;
        this.tableData.data = allData.slice(start, start + this.pagination.perPage);
        this.tableDataReady = true;
      }
      catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
      }
    },
    async fetchHistoryTableData() {
      let toolReserveUrl = `/Tool/Reservations?currentPage=${this.pagination.currentPage}&pageSize=${this.pagination.perPage}&toolId=${this.toolId}&unreserved=true&orderByReservedTimestamp=false&orderByDescending=true&excludeImages=true`;
      const reservationHistorySettings = this.askForToolImageOnReturnForToolReservations ? {
        enableCustomAction: true,
        customAction: this.showReservationImages,
        shouldShowCustomAction: this.shouldShowCustomAction,
        customActionIcon: 'Picture',
      } : null;
      if(this.userRole === 'User')
      {
        this.tableData = {
          title: this.$t('projects.reservationHistory'),
          columns: [
            { prop: 'project', label: this.$t('common.project'), minWidth: 100 },
            { prop: 'reserved', label: this.$t('tools.reserved'), minWidth: 100 },
            { prop: 'returned', label: this.$t('tools.returned'), minWidth: 100 },
            { label: this.$t('common.info'), minWidth: 150, showOnMobile: true, isCompound: true, compound: { 'common.project': 'project', 'tools.reserved': 'reserved','tools.returned': 'returned'}},
          ],
          settings: reservationHistorySettings,
          data: [],
        }
      }
      else
      {
        this.tableData = {
          title: this.$t('projects.reservationHistory'),
          columns: [
            { prop: 'reserved by', label: this.$t('tools.reservedBy'), minWidth: 200},
            { prop: 'project', label: this.$t('common.project'), minWidth: 100 },
            { prop: 'reserved', label: this.$t('tools.reserved'), minWidth: 100 },
            { prop: 'returned', label: this.$t('tools.returned'), minWidth: 100 },
            { label: this.$t('common.info'), minWidth: 150, showOnMobile: true, isCompound: true, compound: { 'tools.reservedBy': 'reserved by', 'common.project': 'project', 'tools.reserved': 'reserved','tools.returned': 'returned'}},
          ],
          settings: reservationHistorySettings,
          data: [],
        }
      }
      this.addPhaseColumn(this.tableData.columns);
      try {
        const response = await api.get(toolReserveUrl);
        this.pagination.total = response.data.totalItems;
        this.tableData.data = response.data.result.map(item => {
          return {
            'reserved': new Date(item.reservedTimestamp).toLocaleDateString('is-IS'),
            'returned': new Date(item.unreservedTimestamp).toLocaleDateString('is-IS'),
            'reserved by': this.userRole === 'User' ? undefined : item.user.firstName + " " + item.user.lastName,
            totalPrice: item.totalPrice,
            id: item.id,
            project: item.project.name,
            phase: item.projectPhaseName || '',
            hasImages: item.toolReservationImages?.length > 0,
          };
        });
        this.tableDataReady = true;
      }
      catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
      }
    },
    async fetchLoanRentHistoryTableData() {
      const loanRentHistorySettings = this.askForToolImageOnReturnForExternalToolReservations ? {
        enableCustomAction: true,
        customAction: this.showExternalReservationImages,
        shouldShowCustomAction: this.shouldShowCustomAction,
        customActionIcon: 'Picture',
      } : null;
      if(this.userRole === 'User')
      {
        this.tableData = {
          title: this.$t('projects.loanRentHistory'),
          columns: [
            { prop: 'externalReservationType', label: this.$t('toolGroups.reservationType'), minWidth: 200 },
            { prop: 'externalUserPhoneNumber', label: this.$t('tools.loanRentToPhoneNumber'), minWidth: 150 },
            { prop: 'reserved', label: this.$t('tools.reserved'), minWidth: 80 },
            { prop: 'returned', label: this.$t('tools.returned'), minWidth: 80 },
            { prop: 'project', label: this.$t('common.project'), minWidth: 100 },
            { label: this.$t('common.info'), minWidth: 150, showOnMobile: true, isCompound: true, compound: { 'toolGroups.reservationType':'externalReservationType', 'tools.loanRentToPhoneNumber':'externalUserPhoneNumber', 'tools.loanedRentedDate': 'reserved', 'tools.returned':'returned', 'common.project':'project'}},
          ],
          settings: loanRentHistorySettings,
          data: [],
        }
      }
      else
      {
        this.tableData = {
          title: this.$t('projects.loanRentHistory'),
          columns: [
            { prop: 'externalReservationType', label: this.$t('toolGroups.reservationType'), minWidth: 200 },
            { prop: 'externalUserPhoneNumber', label: this.$t('tools.loanRentToPhoneNumber'), minWidth: 150 },
            { prop: 'reserved', label: this.$t('tools.reserved'), minWidth: 80 },
            { prop: 'returned', label: this.$t('tools.returned'), minWidth: 80 },
            { prop: 'loanedRentedBy', label: this.$t('tools.loanedRentedBy'), minWidth: 200 },
            { prop: 'project', label: this.$t('common.project'), minWidth: 100 },
            { label: this.$t('common.info'), minWidth: 150, showOnMobile: true, isCompound: true, compound: { 'toolGroups.reservationType':'externalReservationType', 'tools.loanRentToPhoneNumber':'externalUserPhoneNumber', 'tools.loanedRentedDate': 'reserved', 'tools.returned':'returned', 'tools.loanedRentedBy': 'loanedRentedBy', 'common.project':'project'}},
          ],
          settings: loanRentHistorySettings,
          data: [],
        }
      }
      this.addPhaseColumn(this.tableData.columns);
      let toolReserveUrl = `/Tool/Reservations/External?currentPage=${this.pagination.currentPage}&pageSize=${this.pagination.perPage}&toolId=${this.toolId}&unreserved=true&orderByReservedTimestamp=false&orderByDescending=true&excludeImages=true`;
      try {
        const response = await api.get(toolReserveUrl);
        this.pagination.total = response.data.totalItems;
        this.tableData.data = response.data.result.map(item => {
          let reservationType = this.$t('tools.loaned') + " - " + item.externalUser;
          if(item.rented)
          {
            reservationType = this.$t('tools.rented') + " - " + item.externalUser;
          }
          return {
            id: item.id,
            toolId: item.toolId,
            image: 'data:image/jpeg;base64,' + item.tool.toolImageThumbnailBytes, //should be image
            tool: item.tool.name,
            customerToolId: '#' + item.tool.customerToolId,
            reserved: new Date(item.reservedTimestamp).toLocaleDateString('is-IS'),
            returned: new Date(item.unreservedTimestamp).toLocaleDateString('is-IS'),
            externalReservationType: reservationType,
            externalUserPhoneNumber: item.externalUserPhoneNumber || '',
            loanedRentedBy: this.userRole === 'User' ? undefined : item.user.firstName + " " + item.user.lastName,
            totalPrice: item.totalPrice,
            project: item.project !== null ? item.project.name : '',
            phase: item.projectPhaseName || '',
            hasImages: item.externalToolReservationImages?.length > 0,
          };
        });
        this.tableDataReady = true;
      }
      catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
      }
    },
    async fetchRepairHistoryTableData() {
      const isAdmin = this.userRole !== 'User';
      this.tableData = {
        title: this.$t('repairLog.repairHistory'),
        columns: [
          { prop: 'date', label: this.$t('common.date'), minWidth: 100 },
          { prop: 'userName', label: this.$t('tools.employee'), minWidth: 150 },
          { prop: 'fromStatus', label: this.$t('repairLog.fromStatus'), minWidth: 100 },
          { prop: 'toStatus', label: this.$t('repairLog.toStatus'), minWidth: 100 },
          { prop: 'note', label: this.$t('repairLog.note'), minWidth: 250 },
          { label: this.$t('common.info'), minWidth: 150, showOnMobile: true, isCompound: true, compound: { 'common.date':'date', 'tools.employee':'userName', 'repairLog.fromStatus':'fromStatus', 'repairLog.toStatus':'toStatus', 'repairLog.note':'note'}},
        ],
        settings: isAdmin ? {
          enableEdit: true,
          enableDelete: true,
          handleEdit: (_index, row) => this.handleRepairLogEdit(row),
          handleDelete: (_index, row) => this.handleRepairLogDelete(row),
        } : null,
        data: [],
      };
      let repairLogUrl = `/ToolRepairLog/${this.toolId}?currentPage=${this.pagination.currentPage}&pageSize=${this.pagination.perPage}`;
      try {
        const response = await api.get(repairLogUrl);
        this.pagination.total = response.data.totalItems;
        this.tableData.data = response.data.result.map(item => {
          return {
            id: item.id,
            date: new Date(item.createdAt).toLocaleDateString('is-IS'),
            userName: item.userName,
            fromStatus: this.getStatusTranslation(item.fromStatusId),
            toStatus: this.getStatusTranslation(item.toStatusId),
            note: item.note
          };
        });
        this.tableDataReady = true;
      }
      catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
      }
    },
    handleRepairLogEdit(row) {
      this.repairNoteModalTitle = this.$t('common.edit');
      this.repairNoteModalPlaceholder = '';
      this.editingRepairLogId = row.id;
      this.editingRepairLogNote = row.note;
      this.showRepairNoteModal = true;
    },
    handleRepairLogDelete(row) {
      swal.fire({
        title: this.$t('delete.areYouSure'),
        text: this.$t('delete.noRevert'),
        icon: 'warning',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-success btn-fill',
          cancelButton: 'btn btn-danger btn-fill'
        },
        confirmButtonText: this.$t('delete.yesDeleteIt'),
        cancelButtonText: this.$t('delete.cancel'),
        buttonsStyling: false
      }).then(result => {
        if (!result.value) return;
        api.delete(`/ToolRepairLog/${row.id}`)
          .then(() => {
            swal.fire({
              title: this.$t('delete.deleted'),
              text: `${this.$t('delete.youDeleted')} ${row.date} - ${row.userName}`,
              icon: 'success',
              customClass: { confirmButton: 'btn btn-success btn-fill' },
              buttonsStyling: false
            });
            this.fetchRepairHistoryTableData();
          })
          .catch(error => {
            console.error('API request error:', error); // eslint-disable-line no-console
            this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
          });
      });
    },

    // Stats card helper methods
    getStatsIconClass(type) {
      const classes = {
        'success': 'bg-gradient-success',
        'primary': 'bg-gradient-primary',
        'warning': 'bg-gradient-warning',
        'danger': 'bg-gradient-danger',
        'info': 'bg-gradient-info'
      };
      return classes[type] || 'bg-gradient-primary';
    },

    fetchRevenueStats() {
      if (this.userRole === 'User') return;
      
      const analyticsUrl = `/Analytics/Tools/TotalRevenues?toolId=${this.toolId}&includeExternalRevenues=true&includeInternalRevenues=true`;
      api.get(analyticsUrl)
        .then(response => {
          this.totalRevenue = response.data.totalRevenue;
          this.externalRevenue = response.data.externalRevenue;
          this.internalRevenue = response.data.internalRevenue;
          this.totalRevenueCounter = response.data.totalRevenueCounter;
          this.externalRevenueCounter = response.data.externalRevenueCounter;
          this.internalRevenueCounter = response.data.internalRevenueCounter;
          this.profitMultiplier = response.data.profitMultiplier;
          this.populateStatsCards();
        })
        .catch(error => {
          console.error('Error fetching revenue data:', error); // eslint-disable-line no-console
        });
    },

    populateStatsCards() {
      this.statsCards = [
        {
          title: this.formatCurrency(this.totalRevenue),
          subTitle: this.$t('analytics.totalRevenue'),
          type: 'success',
          icon: 'payments',
        },
        {
          title: this.profitMultiplier ? `${this.profitMultiplier.toFixed(2)}x` : 'N/A',
          subTitle: this.$t('analytics.profitMultipler'),
          type: 'primary',
          icon: 'trending_up',
        }
      ];
      this.statusCardsLoaded = true;
    },

    formatCurrency(value) {
      if (value === null || value === undefined) return '0,00 kr';
      return new Intl.NumberFormat('is-IS', {
        style: 'currency',
        currency: 'ISK',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },

    getTooltipContent(index) {
      switch (index) {
        case 0: // Total Revenue card
          return `
            <div style="text-align:left; line-height:1.6;">
              <strong>${this.$t('analytics.totalRevenue')}</strong><br><br>
              ${this.$t('analytics.externalRevenues')}: <strong>${this.formatCurrency(this.externalRevenue)}</strong> (#${this.externalRevenueCounter})<br>
              ${this.$t('analytics.internalRevenues')}: <strong>${this.formatCurrency(this.internalRevenue)}</strong> (#${this.internalRevenueCounter})<br><br>
              <small>${this.$t('analytics.totalUseCountThatGeneratedRevenue')}: ${this.totalRevenueCounter}</small>
            </div>
          `;
        case 1: // Profit Multiplier card
          return `
            <div style="text-align:left; line-height:1.6;">
              <strong>${this.$t('analytics.profitMultipler')}</strong><br><br>
              ${this.$t('analytics.profitMultiplerInfoBubble')}<br><br>
              ${this.formatCurrency(this.totalRevenue)} ÷ ${this.formatCurrency(this.tool.purchasePrice || 0)} 
              = <strong>${this.profitMultiplier ? this.profitMultiplier.toFixed(2) + '×' : 'N/A'}</strong>
            </div>
          `;
        default:
          return '';
      }
    },

    // Tool PDF methods
    showToolPdfs() {
      api.get(`/Tool/${this.toolId}/Pdfs`)
        .then(response => {
          this.toolPdfsList = response.data;
          this.showToolPdfsList = true;
        })
        .catch(error => {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
        });
    },

    closeToolPdfs() {
      this.showToolPdfsList = false;
    },

    goToGeoTraces() {
      this.$router.push({ name: 'Tool GeoTraces', params: { toolId: this.toolId } });
    },

    openToolPdfUpload() {
      this.showToolPdfUpload = true;
    },

    handleToolPdfFiles(event) {
      this.toolPdfUploadFiles = Array.from(event.target.files);
    },

    async uploadToolPdfsToS3() {
      if (this.toolPdfUploadInProgress) return;
      this.toolPdfUploadInProgress = true;
      try {
        if (!this.toolPdfUploadFiles.length) {
          this.$toast.danger(this.$t('tools.noPdfsSelected'), { timeout: 0 });
          this.toolPdfUploadInProgress = false;
          return;
        }
        const pdfRequests = this.toolPdfUploadFiles.map(file => ({
          toolId: this.toolId,
          filename: file.name,
        }));
        const response = await api.post('/Tool/Pdfs/', { pdfs: pdfRequests });
        const uploadInfos = response.data;

        await Promise.all(uploadInfos.map((info, i) =>
          axios.put(info.uploadUrl, this.toolPdfUploadFiles[i], {
            headers: { 'Content-Type': 'application/pdf' },
          })
        ));

        this.$toast.success(this.$t('tools.pdfUploaded'), { timeout: 2500 });
        this.toolPdfUploadInProgress = false;
        this.toolPdfUploadFiles = [];
        if (this.$refs.toolPdfFileInput) this.$refs.toolPdfFileInput.value = '';
        this.showToolPdfUpload = false;
        this.showToolPdfs();
      } catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
        this.toolPdfUploadInProgress = false;
      }
    },

    viewToolPdf(pdf) {
      window.open(pdf.downloadUrl, '_blank');
    },

    downloadToolPdf(pdf) {
      const link = document.createElement('a');
      link.href = pdf.downloadUrl;
      link.download = pdf.filename;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    openReminderModal(reminder = null) {
      this.reminderForm = reminder
        ? {
            id: reminder.id,
            label: reminder.label || '',
            dueDate: reminder.dueDate ? reminder.dueDate.split('T')[0] : '',
            notifyMonthBefore: reminder.notifyMonthBefore || false,
            notifyWeekBefore: reminder.notifyWeekBefore || false,
            notifyOnDate: reminder.notifyOnDate || false,
            recipientUserIds: [...(reminder.recipientUserIds || [])]
          }
        : { id: null, label: '', dueDate: '', notifyMonthBefore: false, notifyWeekBefore: false, notifyOnDate: true, recipientUserIds: [] };
      this.fetchReminderUsers();
      this.showReminderModal = true;
    },
    async fetchReminderUsers() {
      if (this.reminderUsersLoaded) return;
      try {
        // /User returns a PaginatedList ({ result, totalItems, ... }) — unwrap .result
        const res = await api.get('/User', { params: { pageSize: 500, includeDisabled: false, excludeImages: true } });
        this.reminderUserOptions = res.data?.result || [];
        this.reminderUsersLoaded = true;
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
      }
    },
    async saveReminder() {
      if (!this.reminderForm.label || !this.reminderForm.label.trim()) {
        this.$toast.warning(this.$t('errors.reminderLabelEmpty'), { timeout: 2500 });
        return;
      }
      if (!this.reminderForm.dueDate) {
        this.$toast.warning(this.$t('errors.reminderDateEmpty'), { timeout: 2500 });
        return;
      }
      this.reminderSaving = true;
      try {
        const payload = {
          label: this.reminderForm.label,
          dueDate: this.reminderForm.dueDate,
          notifyMonthBefore: this.reminderForm.notifyMonthBefore,
          notifyWeekBefore: this.reminderForm.notifyWeekBefore,
          notifyOnDate: this.reminderForm.notifyOnDate,
          recipientUserIds: this.reminderForm.recipientUserIds
        };
        if (!this.tool.reminders) {
          this.tool.reminders = [];
        }
        if (this.reminderForm.id) {
          const res = await api.put(`/Tool/Reminders/${this.reminderForm.id}`, payload);
          const index = this.tool.reminders.findIndex(r => r.id === this.reminderForm.id);
          if (index !== -1) {
            this.tool.reminders.splice(index, 1, res.data);
          }
        } else {
          const res = await api.post('/Tool/Reminders', { toolId: this.tool.id, ...payload });
          this.tool.reminders.push(res.data);
        }
        this.showReminderModal = false;
      } catch (error) {
        console.error(error); // eslint-disable-line no-console
        this.$toast.danger(getApiErrorMessage(this.$t, error), { timeout: 0 });
      } finally {
        this.reminderSaving = false;
      }
    },
    async deleteReminder(reminder) {
      try {
        await api.delete(`/Tool/Reminders/${reminder.id}`);
        this.tool.reminders = (this.tool.reminders || []).filter(r => r.id !== reminder.id);
        this.$toast.success(this.$t('delete.deleted'), { timeout: 2500 });
      } catch (error) {
        console.error(error); // eslint-disable-line no-console
        this.$toast.danger(getApiErrorMessage(this.$t, error), { timeout: 0 });
      }
    },
    formatReminderDate(dueDate) {
      return dueDate ? dueDate.split('T')[0].split('-').reverse().join('/') : '';
    },
    isReminderOverdue(dueDate) {
      return !!dueDate && dueDate.split('T')[0] < new Date().toISOString().slice(0, 10);
    },
    reminderNotifySummary(reminder) {
      const parts = [];
      if (reminder.notifyMonthBefore) parts.push(this.$t('tools.notifyMonthBefore'));
      if (reminder.notifyWeekBefore) parts.push(this.$t('tools.notifyWeekBefore'));
      if (reminder.notifyOnDate) parts.push(this.$t('tools.notifyOnDate'));
      return parts.join(', ');
    },
    deleteToolPdf(id) {
      api.delete(`/Tool/Pdf/${id}`)
        .then(() => {
          this.$toast.success(this.$t('delete.deleted'), { timeout: 2500 });
          this.showToolPdfs();
        })
        .catch(error => {
          console.error('API request error:', error); // eslint-disable-line no-console
        });
    },

    async showReservationImages(_index, row) {
      try {
        const response = await api.get(`/Tool/Reservation/${row.id}/Images`);
        this.galleryItems = response.data.map(item => ({
          id: item.id,
          src: item.downloadUrl,
          thumbnail: item.downloadUrl,
        }));
        this.showingGallery = true;
      } catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
      }
    },

    async showExternalReservationImages(_index, row) {
      try {
        const response = await api.get(`/Tool/Reservation/External/${row.id}/Images`);
        this.galleryItems = response.data.map(item => ({
          id: item.id,
          src: item.downloadUrl,
          thumbnail: item.downloadUrl,
        }));
        this.showingGallery = true;
      } catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
      }
    },

    shouldShowCustomAction(row) {
      return row.hasImages === true;
    },

    handleImageUpdate(items) {
      this.uploadImages = items;
    },

    clearFilePond() {
      if (this.$refs.pond) this.$refs.pond.removeFiles();
      this.uploadImages = [];
    },

    async uploadImagesToS3() {
      if (this.imageUploadInProgress) return;
      this.imageUploadInProgress = true;
      try {
        if (!this.uploadImages.length) {
          this.$toast.danger(this.$t('tools.noImagesSelected'), { timeout: 0 });
          this.imageUploadInProgress = false;
          return;
        }
        const rawFiles = this.uploadImages.map(item => item.file);
        this.uploadStage = 'compressing';
        this.compressionProgress = { done: 0, total: rawFiles.length };
        const prepared = await compressImagesForUpload(rawFiles, undefined, (done, total) => {
          this.compressionProgress = { done, total };
        });
        this.uploadStage = 'uploading';
        const imageRequests = prepared.map(p => ({
          ...(this.externalToolReservationImageUpload
            ? { externalToolReservationId: this.latestUnreservedId }
            : { toolReservationId: this.latestUnreservedId }),
          filename: p.filename,
        }));
        const endpoint = this.externalToolReservationImageUpload
          ? '/Tool/Reservation/External/Images/'
          : '/Tool/Reservation/Images/';
        const response = await api.post(endpoint, { images: imageRequests });
        const uploadInfos = response.data;
        await Promise.all(uploadInfos.map((info, i) =>
          uploadToPresignedUrl(info.uploadUrl, prepared[i].blob, prepared[i].contentType)
        ));
        this.uploadStage = null;
        this.$toast.success(this.$t('projects.imageUploaded'), { timeout: 2500 });
        this.imageUploadInProgress = false;
        this.clearFilePond();
        this.showImageUpload = false;
        if (this.externalToolReservationImageUpload) {
          this.fetchLoanRentHistoryTableData();
        } else {
          this.fetchHistoryTableData();
        }
      } catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
        this.imageUploadInProgress = false;
        this.uploadStage = null;
      }
    },

  }
};
</script>
<style scoped>
.gallery-thumb {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.gallery-thumb:hover {
  transform: scale(1.03);
}

.tool-info{
  font-size: 1.0624999875rem;
  color: #1d253b;
}
.qr-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.qr-print-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.cancel-new-type {
  padding-left: 10px; /* Adjust as needed */
  padding-top: 10px; /* Adjust as needed */
}
.new-type {
  padding-left: 30px; /* Adjust as needed */
}
@media print {
  h3 {
    color: black !important; /* Force the text color to be black when printed */
    font-weight: bold !important; /* Force the font weight to be bold when printed */
  }
  .qr-print-container {
    width: 100%;
    height: 50vh;
    position: fixed;
    top: 0;
    left: 0;
  }
  .qrcode-vue {
    width: 100%;
    height: auto;
  }
}
.print-logo
  {
    width: 256px;
    padding-bottom: 10px;
  }
.clickable-link {
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
}
.clickable-link:hover {
  color: #0056b3;
}
.black {
  color: black;
}
.blue {
  color: blue;
}
.orange {
  color: orange;
}
.red {
  color: red;
}
.green {
  color: green;
}
.table-min-size {
  min-height: 501px;;
}
/* min-height keeps the two cards visually balanced; no max-height so long
   content (e.g. the GPS device row) grows the card instead of overflowing it */
.max-size-free {
  min-height: 520px;
}
.max-size-reservation {
  min-height: 600px;
}
.max-size-image {
  max-height: 300px;
  max-width: 100%;
  object-fit: contain;
}
.nav-item {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.navbar-nav .nav-item.dropdown .dropdown-toggle.btn.btn-primary.btn-block {
  background-color: #0275d8; /* Bootstrap primary blue */
  border-color: #0275d8;
  color: white; /* Ensure text is visible */
  width: 100%; /* Full row width */
  text-align: center; /* Center text */
  padding: 0.5rem 1rem; /* Adjust padding for button-like feel */
}
.dropdown-menu {
  min-width: 100%; /* Make menu full width like button */
  transform: translateX(0) !important; /* Override any transforms */
}
.dropdown-item {
  display: flex;
  align-items: center; /* Align icons and text vertically */
  padding: 0.5rem 1rem; /* Standard Bootstrap padding */
}
.dropdown-item i {
  font-size: 1.25rem; /* Slightly larger icons for visibility */
  margin-right: 0.5rem; /* Space between icon and text */
}

.dropdown-toggle::after {
  display: none !important;  /* Hide Bootstrap's default arrow/box */
}

/* Stats Card Styles */
.stats-card-wrapper {
  display: block;
  cursor: pointer;
  margin: 10px 20px;
}

.stats-card-wrapper:hover {
  transform: translateY(-2px);
  transition: transform 0.2s ease;
}

.icon-shape {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
}

.icon-shape i {
  font-size: 1.25rem;
  color: #fff;
}

.bg-gradient-success {
  background: linear-gradient(195deg, #66BB6A, #43A047);
}

.bg-gradient-primary {
  background: linear-gradient(195deg, #EC407A, #D81B60);
}

.bg-gradient-warning {
  background: linear-gradient(195deg, #FFA726, #FB8C00);
}

.bg-gradient-danger {
  background: linear-gradient(195deg, #EF5350, #E53935);
}

.bg-gradient-info {
  background: linear-gradient(195deg, #49a3f1, #1A73E8);
}

.custom-icon-fit {
  height: 30px;
  scale: 2;
}

.tool-pdf-item {
  padding: 8px 12px;
  border-radius: 6px;
  background: #f8f9fa;
}

.tool-pdf-item:hover {
  background: #e9ecef;
}

.tool-pdf-item a {
  color: #344767;
}

.tool-pdf-item a:hover {
  color: #1a73e8;
}
</style>